const STORE_COORDS={"1902":[42.0451,-87.6877],"1907":[42.0292,-87.8326],"1913":[42.0664,-87.9373],"1922":[42.3704,-87.9400],"1926":[42.1720,-87.8448],"1938":[42.2211,-87.9562],"1941":[42.3636,-87.8448],"1981":[42.0162,-87.8326],"1987":[42.0987,-87.8326],"6981":[42.2617,-88.0059],"8431":[42.3731,-88.0748],"1921":[41.8878,-88.3048],"1934":[42.0422,-88.2773],"1939":[41.6786,-88.0620],"1957":[41.7606,-88.3201],"1962":[41.5250,-88.0817],"1975":[41.6828,-88.3412],"1977":[41.3364,-89.1320],"6887":[41.6414,-88.4441],"6923":[41.9928,-88.2131],"6925":[41.5278,-88.2048],"1903":[41.9742,-87.7696],"1911":[41.8456,-87.7534],"1912":[41.9108,-87.6876],"1914":[41.7355,-87.6501],"1950":[41.8827,-87.6390],"1961":[41.9578,-87.7001],"1974":[41.9580,-87.7534],"1976":[41.8694,-87.6455],"1980":[41.9397,-87.7221],"1986":[41.7842,-87.6835],"8598":[41.9242,-87.6584],"3001":[38.9517,-92.3341],"3003":[38.7617,-90.4432],"3009":[38.7831,-90.4969],"3013":[38.7445,-90.3049],"3015":[38.8117,-90.6998],"3022":[38.7886,-90.6290],"3025":[38.8117,-90.8590],"3027":[38.1867,-92.6418],"3034":[38.7953,-90.3227],"3036":[40.1953,-92.5830],"1906":[41.6033,-87.8623],"1932":[41.5139,-87.7387],"1967":[39.4792,-88.3731],"1983":[41.7842,-87.8751],"1984":[40.1164,-88.2434],"1989":[41.6017,-87.9401],"2034":[40.4259,-86.9081],"6822":[41.6739,-87.7290],"6919":[41.4814,-87.8290],"8918":[39.9647,-86.8953],"1904":[42.0422,-88.0620],"1920":[42.2317,-88.3273],"1927":[42.1108,-87.9962],"1928":[42.2711,-89.0940],"1940":[42.1553,-88.3412],"1944":[42.3431,-88.1509],"1948":[42.1211,-88.2773],"1952":[42.1928,-88.0912],"1956":[42.3317,-89.0551],"1969":[42.3286,-88.2634],"3002":[38.6231,-90.3496],"3004":[38.5953,-90.5363],"3007":[38.5814,-90.3965],"3010":[38.5317,-90.3496],"3014":[38.4317,-90.3727],"3018":[38.5953,-90.5869],"3032":[38.2317,-90.4012],"3033":[36.7592,-90.4134],"3037":[38.6953,-90.3650],"8994":[38.6531,-90.5869],"1901":[41.8639,-87.8623],"1908":[41.7842,-87.7534],"1909":[41.6153,-87.5290],"1935":[41.7106,-87.7831],"1936":[41.5597,-87.6623],"1937":[41.4778,-87.4401],"1955":[41.7131,-87.7534],"2001":[41.4731,-87.3290],"2030":[41.4731,-87.0623],"2036":[41.5847,-87.5001],"1905":[41.7514,-87.9834],"1916":[41.8086,-88.0115],"1917":[41.9108,-88.0620],"1918":[41.7653,-88.1509],"1919":[41.9153,-87.8918],"1942":[41.7264,-88.0481],"1943":[41.9928,-88.1231],"1964":[41.9714,-88.2048],"1982":[41.8639,-87.9623],"6701":[42.0017,-87.9834],"1851":[38.5214,-90.0001],"1915":[39.9317,-91.4134],"1924":[38.5897,-89.9112],"1973":[38.8231,-89.9501],"1978":[40.6953,-89.5869],"3011":[38.6314,-90.2496],"6920":[38.8897,-90.1840],"6961":[38.6703,-89.9946],"6987":[40.5139,-88.9912],"8430":[39.7317,-90.2273]};
import { useState, useEffect, useRef } from "react";

const C = {
  orange:"#F96302",od:"#D94F00",ol:"#FFF3EB",
  black:"#1A1A1A",g5:"#777",g4:"#999",g3:"#BBB",g1:"#F5F5F5",
  white:"#FFF",border:"#E2E2E2",
  green:"#2E7D32",gl:"#E8F5E9",
  red:"#C62828",rl:"#FFEBEE",
  blue:"#1565C0",bl:"#E3F2FD",
};

const ALERTS = [];
const SEASONAL = [29,33,44,57,68,78,83,81,73,61,47,33];
const getSeasonal = () => SEASONAL[new Date().getMonth()];
const DATA_SOURCE = "Open-Meteo ECMWF";
const DATA_DATE=(function(){var d=new Date();var dn=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];var mn=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];return dn[d.getDay()]+", "+mn[d.getMonth()]+" "+d.getDate()+", "+d.getFullYear();}());
const LAST_WEEK_DATE=(function(){var d=new Date();d.setDate(d.getDate()-1);var dn=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];var mn=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];return dn[d.getDay()]+", "+mn[d.getMonth()]+" "+d.getDate();}());

const COND_ICONS = {
  "Sunny":"☀️","Mostly Sunny":"🌤️","Mainly Clear":"🌤️","Mostly Clear":"🌤️","Partly Sunny":"🌤️","Partly Cloudy":"⛅","Mostly Cloudy":"🌥️","Cloudy":"☁️","Overcast":"☁️",
  "Foggy":"🌫️","Rain":"🌧️","Drizzle":"🌦️","Snow":"❄️","Flurries":"🌨️",
  "Thunderstorm":"⛈️","Sleet":"🌨️","Mixed":"🌡️","Unknown":"🌡️",
};
const COND_GOOD = ["Sunny","Mainly Clear","Mostly Sunny","Mostly Clear"];
const COND_PRECIP = ["Rain","Drizzle","Snow","Flurries","Thunderstorm","Sleet"];

const condIcon  = c => COND_ICONS[c] || "🌡️";
const condGood  = c => COND_GOOD.includes(c);
const condPrecip= c => COND_PRECIP.includes(c);
const DISTRICTS = [
  {dm:"Jonathan Shigley",num:38,key:"Shigley",region:"Chicago North",anchor:"Gurnee IL",stores:[
    {name:"Evanston",state:"IL",num:"1902",anchor:"Chicago IL"},{name:"Niles (Civic Ctr)",state:"IL",num:"1907",anchor:"Chicago IL"},
    {name:"Mt. Prospect",state:"IL",num:"1913",anchor:"Schaumburg IL"},{name:"Gurnee",state:"IL",num:"1922"},
    {name:"Deerfield",state:"IL",num:"1926"},{name:"Vernon Hills",state:"IL",num:"1938"},
    {name:"Waukegan",state:"IL",num:"1941"},{name:"Niles (Dempster)",state:"IL",num:"1981",anchor:"Chicago IL"},
    {name:"Glenview",state:"IL",num:"1987",anchor:"Chicago IL"},{name:"Mundelein",state:"IL",num:"6981"},
    {name:"Round Lake Beach",state:"IL",num:"8431"},
  ]},
  {dm:"John Girves",num:48,key:"Girves",region:"Chicago West",anchor:"Aurora IL",stores:[
    {name:"Geneva",state:"IL",num:"1921"},{name:"Elgin",state:"IL",num:"1934",anchor:"Schaumburg IL"},
    {name:"Bolingbrook",state:"IL",num:"1939",anchor:"Naperville IL"},{name:"Aurora",state:"IL",num:"1957"},
    {name:"Joliet",state:"IL",num:"1962",anchor:"Naperville IL"},{name:"Oswego",state:"IL",num:"1975",anchor:"Naperville IL"},
    {name:"Peru",state:"IL",num:"1977"},{name:"Yorkville",state:"IL",num:"6887"},
    {name:"South Elgin",state:"IL",num:"6923",anchor:"Schaumburg IL"},{name:"Shorewood",state:"IL",num:"6925",anchor:"Naperville IL"},
  ]},
  {dm:"Gary Hutchinson",num:65,key:"Hutchinson",region:"Chicago City",anchor:"Chicago IL",stores:[
    {name:"Chicago (Normandy)",state:"IL",num:"1903"},{name:"Cicero",state:"IL",num:"1911"},
    {name:"Chicago (N Ave)",state:"IL",num:"1912"},{name:"Chicago (87th St)",state:"IL",num:"1914"},
    {name:"Chicago (Clinton)",state:"IL",num:"1950"},{name:"Chicago (Elston)",state:"IL",num:"1961"},
    {name:"Chicago (N Cicero)",state:"IL",num:"1974"},{name:"Chicago (Halsted)",state:"IL",num:"1976"},
    {name:"Chicago (Kimball)",state:"IL",num:"1980"},{name:"Chicago (Western)",state:"IL",num:"1986"},
    {name:"Chicago (Lincoln)",state:"IL",num:"8598"},
  ]},
  {dm:"Kevin Longwell",num:80,key:"Longwell",region:"Missouri",anchor:"St Charles MO",stores:[
    {name:"Columbia",state:"MO",num:"3001"},{name:"Bridgeton",state:"MO",num:"3003"},
    {name:"St. Charles",state:"MO",num:"3009"},{name:"Ferguson",state:"MO",num:"3013"},
    {name:"O'Fallon MO",state:"MO",num:"3015"},{name:"St. Peters",state:"MO",num:"3022"},
    {name:"Wentzville",state:"MO",num:"3025"},{name:"Osage Beach",state:"MO",num:"3027"},
    {name:"Florissant",state:"MO",num:"3034"},{name:"Kirksville",state:"MO",num:"3036"},
  ]},
  {dm:"Angel Mayoski",num:98,key:"Mayoski",region:"Chicago South",anchor:"Orland Park IL",stores:[
    {name:"Orland Park",state:"IL",num:"1906"},{name:"Matteson",state:"IL",num:"1932"},
    {name:"Mattoon",state:"IL",num:"1967",anchor:"Belleville IL"},{name:"Countryside",state:"IL",num:"1983"},
    {name:"Champaign",state:"IL",num:"1984",anchor:"Belleville IL"},{name:"Homer Glen",state:"IL",num:"1989"},
    {name:"Lafayette",state:"IN",num:"2034",anchor:"Lafayette IN"},{name:"Alsip",state:"IL",num:"6822"},
    {name:"Frankfort",state:"IL",num:"6919"},{name:"Crawfordsville",state:"IN",num:"8918",anchor:"Lafayette IN"},
  ]},
  {dm:"Heather Colon",num:145,key:"Colon",region:"Chicago NW",anchor:"Schaumburg IL",stores:[
    {name:"Schaumburg",state:"IL",num:"1904"},{name:"Crystal Lake",state:"IL",num:"1920"},
    {name:"Palatine",state:"IL",num:"1927"},{name:"Rockford",state:"IL",num:"1928",anchor:"Aurora IL"},
    {name:"Algonquin",state:"IL",num:"1940"},{name:"Ingleside",state:"IL",num:"1944",anchor:"Gurnee IL"},
    {name:"Carpentersville",state:"IL",num:"1948"},{name:"Lake Zurich",state:"IL",num:"1952"},
    {name:"Machesney Park",state:"IL",num:"1956",anchor:"Aurora IL"},{name:"McHenry",state:"IL",num:"1969"},
  ]},
  {dm:"Tom Harris",num:150,key:"Harris",region:"St. Louis",anchor:"Chesterfield MO",stores:[
    {name:"Brentwood",state:"MO",num:"3002"},{name:"Ballwin",state:"MO",num:"3004"},
    {name:"St. Louis (Sunset)",state:"MO",num:"3007"},{name:"South County",state:"MO",num:"3010"},
    {name:"Arnold",state:"MO",num:"3014"},{name:"Ellisville",state:"MO",num:"3018"},
    {name:"Festus",state:"MO",num:"3032"},{name:"Poplar Bluff",state:"MO",num:"3033"},
    {name:"Overland",state:"MO",num:"3037"},{name:"Chesterfield",state:"MO",num:"8994"},
  ]},
  {dm:"Joe Becton",num:242,key:"Becton",region:"Chicago SW/IN",anchor:"Oak Lawn IL",stores:[
    {name:"Broadview",state:"IL",num:"1901"},{name:"Chicago (S Cicero)",state:"IL",num:"1908"},
    {name:"Calumet City",state:"IL",num:"1909"},{name:"Chicago Ridge",state:"IL",num:"1935"},
    {name:"Homewood",state:"IL",num:"1936"},{name:"Schererville",state:"IN",num:"1937",anchor:"Valparaiso IN"},
    {name:"Oak Lawn",state:"IL",num:"1955"},{name:"Merrillville",state:"IN",num:"2001",anchor:"Valparaiso IN"},
    {name:"Valparaiso",state:"IN",num:"2030",anchor:"Valparaiso IN"},{name:"Hammond",state:"IN",num:"2036",anchor:"Valparaiso IN"},
  ]},
  {dm:"Tom Pimentel",num:257,key:"Pimentel",region:"Chicago DuPage",anchor:"Naperville IL",stores:[
    {name:"Darien",state:"IL",num:"1905"},{name:"Downers Grove",state:"IL",num:"1916"},
    {name:"Glendale Hts.",state:"IL",num:"1917"},{name:"Naperville",state:"IL",num:"1918"},
    {name:"Northlake",state:"IL",num:"1919"},{name:"Woodridge",state:"IL",num:"1942"},
    {name:"Carol Stream",state:"IL",num:"1943"},{name:"Bartlett",state:"IL",num:"1964"},
    {name:"Oakbrook Terrace",state:"IL",num:"1982"},{name:"Elk Grove Village",state:"IL",num:"6701"},
  ]},
  {dm:"Rafael Colberg",num:299,key:"Colberg",region:"Southern IL/STL",anchor:"Belleville IL",stores:[
    {name:"Belleville",state:"IL",num:"1851"},{name:"Quincy",state:"IL",num:"1915"},
    {name:"O'Fallon IL",state:"IL",num:"1924"},{name:"Edwardsville",state:"IL",num:"1973"},
    {name:"Peoria",state:"IL",num:"1978",anchor:"Aurora IL"},{name:"St. Louis (Kingshwy)",state:"MO",num:"3011",anchor:"Chesterfield MO"},
    {name:"Alton",state:"IL",num:"6920"},{name:"Collinsville",state:"IL",num:"6961"},
    {name:"Normal",state:"IL",num:"6987",anchor:"Naperville IL"},{name:"Jacksonville",state:"IL",num:"8430"},
  ]},
];
// All weather data is per-store and live — no baked fallbacks, no anchors
const FC = {};           // current + 7-day forecast, keyed by store num
const FC_LIVE = new Set(); // nums that have loaded from NWS
const LW = {};           // last week strip [{day,high,cond}], keyed by store num
const LY = {};           // last year strip [{day,high,cond}], keyed by store num
const NW = {};           // next week strip [{day,high,cond,precip}], keyed by store num
// fhigh: always returns today's FORECAST high, not current conditions temp
const fhigh = n => (FC[n]&&FC[n].forecast&&FC[n].forecast[0]&&FC[n].forecast[0].high) || (FC[n]&&FC[n].high) || 0;
const DAYS=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const dLabel = i => i===0?"Today":i===1?"Tom":DAYS[new Date(Date.now()+i*86400000).getDay()];
const avg = getSeasonal();

// ─── Shared summary engine ────────────────────────────────────────────────
// Returns {today, tomorrow, week, nextWeek} strings — any field may be null
// if the underlying data is missing (caller hides the blurb).
//
// inputs:
//   highs      – array of today's highs (stores or anchor averages)
//   forecast   – array of {day,high,cond,precip} for the week
//   lwHighs    – array of last-week highs for same set (for vs LW delta)
//   lyHighs    – array of same-date last-year highs (for vs LY delta)
//   nwHighs    – array of next-week highs (index 5-6 of forecast, or NEXT_WEEK_STRIP)
//   storeCount – number of stores in the set (for labeling)
//   label      – short label like "D3 Harris" or "102 stores" (used in sentences)
function buildSummary({highs, forecast, lwHighs, lyHighs, nwHighs, storeCount, label, extras}) {
  try {
    var sea = getSeasonal();
    var dn = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    var td = dn[new Date().getDay()];
    var tm = dn[(new Date().getDay()+1)%7];
    var ex = extras || {};

    // ── TODAY ──
    if (!highs || !highs.length) return null;
    var todayAvg = Math.round(highs.reduce(function(a,b){return a+b;},0)/highs.length);
    var vsSeaToday = todayAvg - sea;
    var seaStr = vsSeaToday > 0 ? "+" + vsSeaToday + "°F vs seasonal" : vsSeaToday === 0 ? "at seasonal avg" : Math.abs(vsSeaToday) + "°F below seasonal";
    var lwAvg = (lwHighs && lwHighs.length) ? Math.round(lwHighs.reduce(function(a,b){return a+b;},0)/lwHighs.length) : null;
    var lyAvg = (lyHighs && lyHighs.length) ? Math.round(lyHighs.reduce(function(a,b){return a+b;},0)/lyHighs.length) : null;
    var lwDelta = lwAvg != null ? todayAvg - lwAvg : null;
    var lyDelta = lyAvg != null ? todayAvg - lyAvg : null;
    var precipFC = forecast && forecast[0];
    var hasPrecip = precipFC && (precipFC.precip >= 40 || ["Rain","Snow","Thunderstorm","Drizzle","Sleet","Flurries"].indexOf(precipFC.cond) >= 0);

    // Insight 1: store count with rain + which districts hit hardest
    var rainStoreStr = "";
    if (ex.rainStores != null && storeCount > 1) {
      if (ex.rainStores > 0) {
        rainStoreStr = ex.rainStores + " of " + storeCount + " stores seeing precip today";
        if (ex.hardestDistrict) rainStoreStr += " — heaviest in " + ex.hardestDistrict;
        rainStoreStr += ".";
      } else {
        rainStoreStr = "All " + storeCount + " stores clear of precipitation today.";
      }
    }

    // Insight 2: regional split (IL vs MO) if applicable
    var splitStr = "";
    if (ex.ilAvg != null && ex.moAvg != null) {
      var diff = ex.ilAvg - ex.moAvg;
      if (Math.abs(diff) >= 4) {
        splitStr = (diff > 0 ? "IL/IN running " + diff + "°F warmer than MO." : "MO running " + Math.abs(diff) + "°F warmer than IL/IN.");
      }
    }

    // Build today string
    var parts = [td + ": " + todayAvg + "°F avg (" + seaStr + ")."];
    var comps = [];
    if (lwDelta != null) comps.push((lwDelta > 0 ? "+" : "") + lwDelta + "°F vs same day last week");
    if (lyDelta != null) comps.push((lyDelta > 0 ? "+" : "") + lyDelta + "°F vs same date last year");
    if (comps.length) parts.push(comps.join(", ") + ".");
    if (hasPrecip && precipFC.precip) parts.push(precipFC.precip + "% precip probability.");
    if (rainStoreStr) parts.push(rainStoreStr);
    if (splitStr) parts.push(splitStr);
    var todayStr = parts.join(" ");

    // ── TOMORROW ──
    var tmrFC = forecast && forecast[1];
    var tmrStr = null;
    if (tmrFC && tmrFC.high) {
      var tmrDelta = tmrFC.high - todayAvg;
      var tmrSeaDelta = tmrFC.high - sea;
      var tmrTrend = Math.abs(tmrDelta) >= 3 ? (tmrDelta > 0 ? "+" + tmrDelta + "°F from today" : tmrDelta + "°F from today") : "flat vs today";
      var tmrSeaStr = tmrSeaDelta > 0 ? "+" + tmrSeaDelta + "°F vs seasonal" : tmrSeaDelta === 0 ? "at seasonal" : Math.abs(tmrSeaDelta) + "°F below seasonal";
      var tmrPrecip = (tmrFC.precip >= 40 || ["Rain","Snow","Thunderstorm","Drizzle","Sleet","Flurries"].indexOf(tmrFC.cond) >= 0);
      var tmrParts = [tm + ": " + tmrFC.high + "°F (" + tmrTrend + ", " + tmrSeaStr + ")."];
      if (tmrPrecip && tmrFC.precip) tmrParts.push(tmrFC.precip + "% precip probability.");
      // Tomorrow store impact
      if (ex.tmrRainStores != null && storeCount > 1 && ex.tmrRainStores > 0) {
        tmrParts.push(ex.tmrRainStores + " of " + storeCount + " stores with precip risk tomorrow.");
      }
      if (splitStr) tmrParts.push(splitStr);
      tmrStr = tmrParts.join(" ");
    }

    // ── THIS WEEK ──
    var weekStr = null;
    if (forecast && forecast.length >= 3) {
      var validFC = forecast.filter(function(f){return f && f.high;});
      if (validFC.length) {
        var weekAvg = Math.round(validFC.reduce(function(a,b){return a+b.high;},0)/validFC.length);
        var weekSeaDelta = weekAvg - sea;
        var weekSeaStr = weekSeaDelta > 0 ? "+" + weekSeaDelta + "°F above seasonal" : weekSeaDelta === 0 ? "at seasonal" : Math.abs(weekSeaDelta) + "°F below seasonal";
        var sorted = validFC.slice().sort(function(a,b){return b.high-a.high;});
        var bestDay = sorted[0];
        var precipDays = validFC.filter(function(f){return f.precip>=40||["Rain","Snow","Thunderstorm","Drizzle","Sleet","Flurries"].indexOf(f.cond)>=0;});
        var cleanDays = validFC.filter(function(f){return !condPrecip(f.cond)&&f.precip<40;});
        var wkComps = [];
        if (lwAvg != null) wkComps.push((weekAvg-lwAvg > 0?"+":"")+(weekAvg-lwAvg)+"°F vs last week");
        if (lyAvg != null) wkComps.push((weekAvg-lyAvg > 0?"+":"")+(weekAvg-lyAvg)+"°F vs last year");
        var wkParts = ["Week avg: " + weekAvg + "°F (" + weekSeaStr + (wkComps.length?"; "+wkComps.join(", "):"") + ")."];
        wkParts.push("Best day " + (bestDay.day||"—") + " at " + bestDay.high + "°F.");
        if (precipDays.length) {
          wkParts.push(precipDays.length + " day" + (precipDays.length>1?"s":"") + " with ≥40% precip (" + precipDays.map(function(f){return f.day;}).filter(Boolean).join(", ") + ").");
        } else {
          wkParts.push("No significant precip expected all week.");
        }
        if (cleanDays.length >= 2 && ex.bestWindowDistrict) {
          wkParts.push("Cleanest window: " + cleanDays.slice(0,2).map(function(f){return f.day;}).filter(Boolean).join("-") + ".");
        }
        if (splitStr) wkParts.push(splitStr);
        weekStr = wkParts.join(" ");
      }
    }

    // ── NEXT WEEK ──
    var nwStr = null;
    if (nwHighs && nwHighs.length) {
      var nwAvg = Math.round(nwHighs.reduce(function(a,b){return a+b;},0)/nwHighs.length);
      var nwSeaDelta = nwAvg - sea;
      var nwSeaStr = nwSeaDelta > 0 ? "+" + nwSeaDelta + "°F vs seasonal" : nwSeaDelta === 0 ? "at seasonal" : Math.abs(nwSeaDelta) + "°F below seasonal";
      var nwVsTW = Math.round(nwAvg - todayAvg);
      var nwTrend = Math.abs(nwVsTW) >= 3 ? (nwVsTW > 0 ? "+" + nwVsTW + "°F vs this week" : nwVsTW + "°F vs this week") : "flat vs this week";
      var nwLYStr = lyAvg != null ? "; " + (nwAvg-lyAvg > 0?"+":"") + (nwAvg-lyAvg) + "°F vs last year" : "";
      var nwParts = ["Next week avg: " + nwAvg + "°F (" + nwSeaStr + ", " + nwTrend + nwLYStr + ")."];
      if (ex.nwRainDays != null) {
        if (ex.nwRainDays > 0) nwParts.push(ex.nwRainDays + " of 7 days showing ≥40% precip risk.");
        else nwParts.push("Currently showing dry conditions all week.");
      }
      if (splitStr) nwParts.push(splitStr);
      nwStr = nwParts.join(" ");
    }

    return { today: todayStr, tomorrow: tmrStr, week: weekStr, nextWeek: nwStr };
  } catch(e) { return null; }
}
// ─────────────────────────────────────────────────────────────────────────

const Chip = ({children,color,sm}) => {
  const m={green:{bg:C.gl,tx:C.green,bd:"#A5D6A7"},red:{bg:C.rl,tx:C.red,bd:"#FFAAAA"},
    orange:{bg:C.ol,tx:C.od,bd:"#FFCC99"},blue:{bg:C.bl,tx:C.blue,bd:"#90CAF9"},
    gray:{bg:C.g1,tx:C.g5,bd:C.border}}[color]||{bg:C.g1,tx:C.g5,bd:C.border};
  return <span style={{background:m.bg,color:m.tx,border:"1px solid "+m.bd,borderRadius:5,
    fontSize:sm?"0.55rem":"0.62rem",fontWeight:700,padding:sm?"1px 5px":"2px 7px",whiteSpace:"nowrap"}}>{children}</span>;
};

function Strip({forecast}) {
  return (
    <div style={{display:"flex",gap:4,overflowX:"auto",paddingBottom:2}}>
      {(forecast||[]).map((f,i)=>(
        <div key={i} style={{flex:"0 0 auto",width:46,borderRadius:8,padding:"7px 4px",textAlign:"center",
          background:i===0?C.ol:C.white,border:"1.5px solid "+(i===0?C.orange:C.border)}}>
          <div style={{fontSize:"0.55rem",color:i===0?C.orange:C.g3,fontWeight:700,marginBottom:1}}>{f.day}</div>
          <div style={{fontSize:"1.05rem"}}>{condIcon(f.cond)}</div>
          <div style={{fontSize:"0.72rem",fontWeight:800,color:C.black}}>{f.high}°</div>
          <div style={{fontSize:"0.6rem",color:C.g5}}>{f.low}°</div>
          {f.precip>10&&<div style={{fontSize:"0.55rem",color:C.blue,fontWeight:600,marginTop:1}}>{f.precip}%</div>}
        </div>
      ))}
    </div>
  );
}

function Card({store,district,onSelect}) {
  const [exp,setExp]=useState(false);
  const w = FC[store.num];
  if (!w) return (
    <div style={{borderRadius:10,background:C.white,border:"1px solid "+C.border,padding:"12px 13px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}} onClick={onSelect}>
      <div>
        <div style={{fontSize:"0.82rem",fontWeight:700,color:C.black}}>{store.name}</div>
        <div style={{fontSize:"0.65rem",color:C.g4,marginTop:2}}>{"#"+store.num+" · Loading..."}</div>
      </div>
      <div style={{width:18,height:18,borderRadius:"50%",border:"2px solid rgba(249,99,2,0.2)",borderTopColor:C.orange,animation:"spin 0.7s linear infinite"}}/>
    </div>
  );
  const good  = condGood(w.cond) && w.high >= avg;
  const hasAlert = condPrecip(w.cond);
  const diff  = LY[store.num] ? w.high - LY[store.num][LY[store.num].length-1].high : null;
  return (
    <div style={{borderRadius:10,overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",
      background:hasAlert?"#FFF8F8":good?"#F4FFF4":C.white,
      border:"1.5px solid "+(hasAlert?C.red:C.border)}}>
      <div style={{padding:"12px 13px",cursor:"pointer"}} onClick={()=>setExp(!exp)}>
        <div style={{display:"flex",justifyContent:"space-between",gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:5,flexWrap:"wrap",marginBottom:3}}>
              <span style={{fontSize:"0.84rem",fontWeight:700,color:C.black}}>{store.name}</span>
              <span style={{fontSize:"0.6rem",color:C.g5,background:C.g1,padding:"1px 5px",borderRadius:4,border:"1px solid "+C.border}}>#{store.num}</span>
              {hasAlert&&<Chip color="red" sm>{"⚠ "+w.cond.toUpperCase()}</Chip>}
              {!hasAlert&&good&&<Chip color="green" sm>✓ GOOD</Chip>}
            </div>
            <span style={{fontSize:"0.68rem",color:C.g5}}>{condIcon(w.cond)} {w.cond} · {store.state}</span>
          </div>
          <div style={{textAlign:"right",flexShrink:0}}>
            <div style={{fontSize:"1.65rem",fontWeight:800,color:C.black,lineHeight:1}}>{w.temp}°</div>
            <div style={{fontSize:"0.6rem",color:C.g5}}>feels {w.feels}°</div>
          </div>
        </div>
        <div style={{display:"flex",gap:9,marginTop:6,fontSize:"0.64rem",color:C.g5,flexWrap:"wrap"}}>
          <span>H <b style={{color:C.black}}>{w.high}°</b></span>
          <span>L <b style={{color:C.black}}>{w.low}°</b></span>
          <span style={{color:w.high>=avg?C.green:C.red}}>{w.high>=avg?"▲":"▼"} Avg {avg}°</span>
          <span>💨{w.wind}mph</span>
          <span>💧{w.humidity}%</span>
          <span style={{marginLeft:"auto",color:C.g3}}>{exp?"▲":"▼"}</span>
        </div>
        {diff!==null&&(
          <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginTop:7,borderRadius:7,padding:"4px 9px",fontSize:"0.64rem",
            background:diff>1?C.ol:diff<-1?C.bl:C.g1,border:"1px solid "+(diff>1?"#FFCC99":diff<-1?"#BDD7FF":C.border)}}>
            <span style={{color:C.g3,fontWeight:700,fontSize:"0.56rem",letterSpacing:"0.06em"}}>VS LY</span>
            <span style={{fontWeight:800,fontSize:"0.8rem",color:diff>1?C.od:diff<-1?C.blue:C.g5}}>{diff>0?"+"+diff+"°":diff+"°"}</span>
            {LY[store.num]&&w.cond!==(LY[store.num][LY[store.num].length-1].cond)&&<><span style={{color:C.g3}}>·</span><span style={{color:C.g5,fontSize:"0.6rem"}}>{condIcon(w.cond)} vs {condIcon(LY[store.num][LY[store.num].length-1].cond)} {LY[store.num][LY[store.num].length-1].cond} LY</span></>}
          </div>
        )}
      </div>
      {exp&&(
        <div style={{borderTop:"1px solid "+C.border,padding:"10px 13px",background:C.g1}}>
          <div style={{fontSize:"0.6rem",fontWeight:700,color:C.g3,letterSpacing:"0.07em",marginBottom:7}}>7-DAY FORECAST</div>
          <Strip forecast={(function(){var fcs=district.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean);if(!fcs.length)return(w&&w.forecast)||[];return[0,1,2,3,4,5,6].map(function(di){var hs=fcs.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=fcs.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=fcs.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);var ds=fcs.map(function(f){return f[di]&&f[di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);}())}/>
          {onSelect&&<button onClick={()=>onSelect(store)} style={{marginTop:10,width:"100%",padding:"9px",borderRadius:8,background:C.orange,color:C.white,border:"none",fontSize:"0.76rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>View Store Detail →</button>}
        </div>
      )}
    </div>
  );
}

function StoreDetail({store,district,onBack}) {
  const w = FC[store.num];
  const lyData = LY[store.num];
  const ly = lyData && lyData.length ? {high: Math.round(lyData.reduce((a,b)=>a+b.high,0)/lyData.length), cond: lyData[Math.floor(lyData.length/2)].cond} : null;
  const todayHigh = fhigh(store.num) || (w && w.high) || 0;
  if (!w) return (
    <div style={{animation:"fadeUp 0.25s ease"}}>
      <button onClick={onBack} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:C.orange,fontSize:"0.82rem",fontWeight:700,marginBottom:14,padding:0,fontFamily:"inherit"}}>
        {"← Back to "+district.dm.split(" ")[1]}
      </button>
      <div style={{background:C.white,borderRadius:14,padding:"32px 18px",border:"1.5px solid "+C.border,textAlign:"center"}}>
        <div style={{width:28,height:28,borderRadius:"50%",border:"3px solid rgba(249,99,2,0.2)",borderTopColor:C.orange,animation:"spin 0.7s linear infinite",margin:"0 auto 12px"}}/>
        <div style={{fontSize:"0.82rem",color:C.g5,fontWeight:600}}>{"Loading "+store.name+"..."}</div>
        <div style={{fontSize:"0.65rem",color:C.g4,marginTop:4}}>{"#"+store.num+" · "+store.state}</div>
      </div>
    </div>
  );
  const good = condGood(w.cond) && todayHigh >= avg;

  // Per-store summary using buildSummary
  const storeSumm = (function(){
    if(!w||!w.high) return null;
    var highs = [w.high];
    var forecast = w.forecast || [];
    var lwHighs = (LW[store.num]||[]).map(function(x){return x.high;}).filter(Boolean);
    var lyHighs = (LY[store.num]||[]).map(function(x){return x.high;}).filter(Boolean);
    var nwHighs = (NW[store.num]||[]).map(function(x){return x.high;}).filter(Boolean);
    return buildSummary({highs:highs, forecast:forecast, lwHighs:lwHighs, lyHighs:lyHighs, nwHighs:nwHighs, storeCount:1, label:"#"+store.num+" "+store.name});
  })();
  const [storeTab, setStoreTab] = useState(0);
  const storeTabKeys = ["today","tomorrow","week","nextWeek"];
  const storeSummText = storeSumm ? storeSumm[storeTabKeys[storeTab]] : null;
  return (
    <div style={{animation:"fadeUp 0.25s ease"}}>
      <button onClick={onBack} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:C.orange,fontSize:"0.82rem",fontWeight:700,marginBottom:14,padding:0,fontFamily:"inherit"}}>
        {"← Back to "+district.dm.split(" ")[1]}
      </button>
      <div style={{background:C.white,borderRadius:14,padding:"18px",border:"1.5px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
          <div>
            <div style={{fontSize:"1.1rem",fontWeight:800,color:C.black,marginBottom:3}}>{store.name}</div>
            <div style={{fontSize:"0.72rem",color:C.g5}}>{"#"+store.num+" · "+store.state+" · "+district.dm}</div>
            <div style={{marginTop:8,display:"flex",gap:6,flexWrap:"wrap"}}>
              {condPrecip(w.cond)&&<Chip color="red">{"⚠ "+w.cond+" Alert"}</Chip>}
              {!condPrecip(w.cond)&&good&&<Chip color="green">✓ Good Conditions</Chip>}
            </div>
          </div>
          <div style={{textAlign:"center",flexShrink:0}}>
            <div style={{fontSize:"3rem",fontWeight:800,color:C.black,lineHeight:1}}>{w.temp}°</div>
            <div style={{fontSize:"0.7rem",color:C.g5}}>{condIcon(w.cond)+" "+w.cond}</div>
            <div style={{fontSize:"0.65rem",color:C.g5}}>{"feels "+w.feels+"°"}</div>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:14}}>
          {[{l:"High",v:todayHigh+"°F"},{l:"Low",v:w.low+"°F"},{l:"Avg High",v:avg+"°F",hi:todayHigh>=avg},{l:"Wind",v:w.wind+" mph"},{l:"Humidity",v:w.humidity+"%"},{l:"Precip",v:w.precip+"%"}].map(x=>(
            <div key={x.l} style={{background:C.g1,borderRadius:9,padding:"10px 12px",border:"1px solid "+C.border,textAlign:"center"}}>
              <div style={{fontSize:"1.1rem",fontWeight:800,color:x.hi!==undefined?(x.hi?C.green:C.red):C.black}}>{x.v}</div>
              <div style={{fontSize:"0.6rem",color:C.g5,fontWeight:600,letterSpacing:"0.04em",marginTop:2}}>{x.l.toUpperCase()}</div>
            </div>
          ))}
        </div>
      </div>
      {ly&&(
        <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginBottom:12}}>
          <div style={{fontSize:"0.7rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em",marginBottom:10}}>{"YEAR OVER YEAR · "+(function(){var d=new Date();d.setFullYear(d.getFullYear()-1);return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});}())}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {[{l:"This Year",v:todayHigh+"°F",sub:condIcon(w.cond)+" "+w.cond},{l:"Last Year",v:ly.high+"°F",sub:condIcon(ly.cond)+" "+ly.cond}].map(x=>(
              <div key={x.l} style={{background:C.g1,borderRadius:9,padding:"12px",border:"1px solid "+C.border,textAlign:"center"}}>
                <div style={{fontSize:"0.6rem",color:C.g5,fontWeight:600,letterSpacing:"0.04em",marginBottom:6}}>{x.l.toUpperCase()}</div>
                <div style={{fontSize:"1.4rem",fontWeight:800,color:C.black}}>{x.v}</div>
                <div style={{fontSize:"0.7rem",color:C.g5,marginTop:3}}>{x.sub}</div>
              </div>
            ))}
          </div>
          <div style={{marginTop:10,padding:"8px 12px",borderRadius:8,textAlign:"center",fontWeight:700,fontSize:"0.78rem",
            background:todayHigh-ly.high>1?C.ol:todayHigh-ly.high<-1?C.bl:C.g1,
            color:todayHigh-ly.high>1?C.od:todayHigh-ly.high<-1?C.blue:C.g5}}>
            {(todayHigh-ly.high>0?"+":"")+Math.round(todayHigh-ly.high)+"° vs same date last year"}
          </div>
        </div>
      )}
      {storeSummText&&(
        <div style={{background:C.black,borderRadius:12,padding:"14px 16px",marginBottom:12,border:"2px solid "+C.orange}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:"0.88rem",fontWeight:800,color:C.white}}>Store Summary</span>
              <span style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.4)",background:"rgba(255,255,255,0.08)",padding:"1px 8px",borderRadius:99}}>{"#"+store.num}</span>
            </div>
            <div style={{display:"flex",gap:3,background:"rgba(255,255,255,0.1)",borderRadius:8,padding:3}}>
              {["Today","Tomorrow","This Week","Next Week"].map((t,i)=>(
                <button key={i} onClick={()=>setStoreTab(i)} style={{padding:"4px 9px",borderRadius:6,fontSize:"0.65rem",fontWeight:600,border:"none",cursor:"pointer",fontFamily:"inherit",minHeight:28,background:storeTab===i?C.orange:"transparent",color:storeTab===i?C.white:"rgba(255,255,255,0.4)"}}>
                  {t}
                </button>
              ))}
            </div>
          </div>
          <p style={{margin:0,color:C.white,fontSize:"0.82rem",lineHeight:1.65}}>{storeSummText}</p>
        </div>
      )}
      <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
        <div style={{fontSize:"0.7rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em",marginBottom:10}}>7-DAY FORECAST</div>
        <Strip forecast={(function(){var fcs=district.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean);if(!fcs.length)return(w&&w.forecast)||[];return[0,1,2,3,4,5,6].map(function(di){var hs=fcs.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=fcs.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=fcs.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);var ds=fcs.map(function(f){return f[di]&&f[di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);}())}/>
      </div>
      {/* Sparkline: last week actuals vs last year */}
      {(function(){
        var lw=LW[store.num];
        var ly=LY[store.num];
        if(!lw||!lw.length)return null;
        var allH=lw.map(function(x){return x.high;}).concat(ly?ly.map(function(x){return x.high;}):[]);
        var minH=Math.min.apply(null,allH)-2;
        var maxH=Math.max.apply(null,allH)+2;
        var range=maxH-minH||1;
        var W=280,H=60,pad=4;
        var pts=function(arr){return arr.map(function(x,i){var px=pad+i*(W-pad*2)/(arr.length-1);var py=H-pad-(x.high-minH)/range*(H-pad*2);return px+","+py;}).join(" ");};
        return(
          <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginTop:12}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
              <div style={{fontSize:"0.7rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em"}}>LAST 7 DAYS vs LAST YEAR</div>
              <div style={{display:"flex",gap:10,fontSize:"0.6rem",color:C.g5}}>
                <span><svg width="16" height="4" style={{verticalAlign:"middle",marginRight:3}}><line x1="0" y1="2" x2="16" y2="2" stroke={C.orange} strokeWidth="2"/></svg>This year</span>
                {ly&&<span><svg width="16" height="4" style={{verticalAlign:"middle",marginRight:3}}><line x1="0" y1="2" x2="16" y2="2" stroke={C.g3} strokeWidth="2" strokeDasharray="3,2"/></svg>Last year</span>}
              </div>
            </div>
            <svg viewBox={"0 0 "+W+" "+H} style={{width:"100%",height:H,overflow:"visible"}}>
              {ly&&<polyline points={pts(ly)} fill="none" stroke={C.g3} strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6"/>}
              <polyline points={pts(lw)} fill="none" stroke={C.orange} strokeWidth="2.5"/>
              {lw.map(function(x,i){var px=pad+i*(W-pad*2)/(lw.length-1);var py=H-pad-(x.high-minH)/range*(H-pad*2);return(
                <g key={i}>
                  <circle cx={px} cy={py} r="3" fill={C.orange}/>
                  <text x={px} y={py-6} textAnchor="middle" fontSize="8" fill={C.g5}>{x.high+"°"}</text>
                </g>
              );})}
            </svg>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
              {lw.map(function(x,i){return<div key={i} style={{fontSize:"0.5rem",color:C.g4,textAlign:"center",flex:1}}>{x.day.slice(0,2).toUpperCase()}</div>;})}
            </div>
          </div>
        );
      })()}
      {/* Sparkline: next 7 days forecast vs last year */}
      {(function(){
        var fc=w&&w.forecast;
        var ly=LY[store.num];
        if(!fc||!fc.length)return null;
        var DN3=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        var today3=new Date();today3.setHours(0,0,0,0);
        var fcData=fc.slice(0,7).map(function(f,i){var d=new Date(today3);d.setDate(today3.getDate()+i);return{high:f.high,day:i===0?"Today":DN3[d.getDay()].slice(0,2).toUpperCase(),precip:f.precip||0,cond:f.cond||""};});
        var allH=fcData.map(function(x){return x.high;}).concat(ly?ly.map(function(x){return x.high;}):[]);
        var minH=Math.min.apply(null,allH)-2;
        var maxH=Math.max.apply(null,allH)+2;
        var range=maxH-minH||1;
        var W=280,H=60,pad=4;
        var pts=function(arr){return arr.map(function(x,i){var px=pad+i*(W-pad*2)/(arr.length-1);var py=H-pad-(x.high-minH)/range*(H-pad*2);return px+","+py;}).join(" ");};
        return(
          <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginTop:12}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
              <div style={{fontSize:"0.7rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em"}}>NEXT 7 DAYS vs LAST YEAR</div>
              <div style={{display:"flex",gap:10,fontSize:"0.6rem",color:C.g5}}>
                <span><svg width="16" height="4" style={{verticalAlign:"middle",marginRight:3}}><line x1="0" y1="2" x2="16" y2="2" stroke={C.blue} strokeWidth="2"/></svg>Forecast</span>
                {ly&&<span><svg width="16" height="4" style={{verticalAlign:"middle",marginRight:3}}><line x1="0" y1="2" x2="16" y2="2" stroke={C.g3} strokeWidth="2" strokeDasharray="3,2"/></svg>Last year</span>}
              </div>
            </div>
            <svg viewBox={"0 0 "+W+" "+H} style={{width:"100%",height:H,overflow:"visible"}}>
              {ly&&<polyline points={pts(ly)} fill="none" stroke={C.g3} strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6"/>}
              <polyline points={pts(fcData)} fill="none" stroke={C.blue} strokeWidth="2.5"/>
              {fcData.map(function(x,i){
                var px=pad+i*(W-pad*2)/(fcData.length-1);
                var py=H-pad-(x.high-minH)/range*(H-pad*2);
                var dotCol=x.precip>=40?C.red:C.blue;
                return(
                  <g key={i}>
                    <circle cx={px} cy={py} r="3" fill={dotCol}/>
                    <text x={px} y={py-6} textAnchor="middle" fontSize="8" fill={C.g5}>{x.high+"°"}</text>
                  </g>
                );
              })}
            </svg>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
              {fcData.map(function(x,i){return<div key={i} style={{fontSize:"0.5rem",color:x.precip>=40?C.red:C.g4,textAlign:"center",flex:1,fontWeight:x.precip>=40?700:400}}>{x.day}</div>;})}
            </div>
            <div style={{fontSize:"0.58rem",color:C.g4,marginTop:6}}>Red dots = ≥40% precip risk</div>
          </div>
        );
      })()}
    </div>
  );
}

function DistrictView({district,onBack,onStore}) {
  const [q,setQ]=useState("");
  const [tab,setTab]=useState(0);
  const [shareOk,setShareOk]=useState(false);
  const stores = district.stores.filter(s =>
    !q || s.name.toLowerCase().includes(q.toLowerCase()) || s.num.includes(q)
  );
  const w = (function(){
    var lh=district.stores.filter(function(s){return FC_LIVE.has(s.num);}).map(function(s){return FC[s.num];}).filter(Boolean);
    if(!lh.length) return null;
    var avgH=Math.round(lh.map(function(x){return x.high||0;}).reduce(function(a,b){return a+b;},0)/lh.length);
    return {high:avgH,temp:avgH,cond:lh[0].cond,forecast:lh[0].forecast,wind:lh[0].wind||10,humidity:lh[0].humidity||60,precip:lh[0].precip||0};
  }());
  const summ=(function(){
    var liveH=district.stores.filter(function(s){return FC_LIVE.has(s.num);}).map(function(s){return fhigh(s.num);}).filter(Boolean);
    if(!liveH.length)return null;
    var allFC=district.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean);
    var forecast=[0,1,2,3,4,5,6].map(function(di){var hs=allFC.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=allFC.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=allFC.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);var ds=allFC.map(function(f){return f[di]&&f[di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    var lwHighs=district.stores.flatMap(function(s){return(LW[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    var lyHighs=district.stores.flatMap(function(s){return(LY[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    var nwHighs=district.stores.flatMap(function(s){return(NW[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    return buildSummary({highs:liveH,forecast:forecast,lwHighs:lwHighs,lyHighs:lyHighs,nwHighs:nwHighs,storeCount:district.stores.length,label:"D"+district.num+" "+district.dm});
  })();
  const hasAlert = w && condPrecip(w.cond);
  const good  = w && condGood(w.cond) && w.high >= avg;
  const delta = (function(){
    if(!w||!w.high)return null;
    var lyH=district.stores.flatMap(function(s){return(LY[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    if(!lyH.length)return null;
    var lyAvg=Math.round(lyH.reduce(function(a,b){return a+b;},0)/lyH.length);
    return w.high-lyAvg;
  }());
  const tabs  = ["Today","Tomorrow","This Week","Next Week"];
  const summText = summ ? ([summ.today, summ.tomorrow, summ.week, summ.nextWeek][tab] || null) : null;

  return (
    <div style={{animation:"fadeUp 0.25s ease"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.orange,fontSize:"0.82rem",fontWeight:700,padding:0,fontFamily:"inherit"}}>{"< All Districts"}</button>
        <button onClick={function(){var fc=w&&w.forecast||[];var fcStr=fc.slice(0,5).map(function(f){return f.day+" "+f.high+"°";}).join(" → ");var txt=["📍 D"+district.num+" "+district.dm+" | "+district.region,DATA_DATE,"Today: "+(w?w.high+"°F "+w.cond:"—"),"Forecast: "+fcStr,"",(summ&&summ.today?"TODAY: "+summ.today:""),(summ&&summ.week?"WEEK: "+summ.week:""),"Hamad Central Weather Digest"].filter(Boolean).join("\n");try{var el=document.createElement("textarea");el.value=txt;el.style.cssText="position:fixed;top:-9999px;left:-9999px;";document.body.appendChild(el);el.select();document.execCommand("copy");document.body.removeChild(el);setShareOk(true);setTimeout(function(){setShareOk(false);},2500);}catch(e){}}} style={{background:shareOk?C.green:C.orange,color:C.white,border:"none",borderRadius:8,padding:"7px 12px",fontSize:"0.72rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
          {shareOk?"✅ Copied!":"📋 Share"}
        </button>
      </div>

      <div style={{background:C.white,borderRadius:14,padding:"16px",
        border:"1.5px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
          <div style={{width:46,height:46,borderRadius:10,background:C.orange,flexShrink:0,
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:"0.78rem",fontWeight:800,color:C.white}}>
            {"D"+district.num}
          </div>
          <div>
            <div style={{fontSize:"1rem",fontWeight:800,color:C.black}}>{district.dm}</div>
            <div style={{fontSize:"0.68rem",color:C.g5,marginTop:1}}>
              {"D"+district.num+" · "+district.stores.length+" stores · "+district.region}
            </div>
          </div>
        </div>
        {w&&(
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            <span style={{fontSize:"1.4rem"}}>{condIcon(w.cond)}</span>
            <span style={{fontSize:"1.1rem",fontWeight:800,color:C.black}}>{w.high+"°F"}</span>
            <Chip color="gray">{w.cond}</Chip>
            {delta!=null&&<Chip color={delta>2?"orange":delta<-2?"blue":"gray"}>{(delta>0?"+":"")+delta+"° vs LY"}</Chip>}
            {hasAlert&&<Chip color="red">{"⚠ "+w.cond+" — All "+stores.length+" stores"}</Chip>}
            {good&&!hasAlert&&<Chip color="green">{"✓ Good — All "+stores.length+" stores"}</Chip>}
          </div>
        )}
      </div>

      {summ&&summText&&(
        <div style={{background:C.black,borderRadius:12,padding:"14px 16px",
          marginBottom:12,border:"2px solid "+C.orange}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
            flexWrap:"wrap",gap:8,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span>{"🤖"}</span>
              <span style={{fontWeight:800,fontSize:"0.88rem",color:C.white}}>District Summary</span>
              <span style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.4)",
                background:"rgba(255,255,255,0.08)",padding:"1px 8px",borderRadius:99}}>
                {district.dm}
              </span>
            </div>
            <div style={{display:"flex",gap:3,background:"rgba(255,255,255,0.1)",borderRadius:8,padding:3}}>
              {tabs.map((t,i)=>(
                <button key={i} onClick={()=>setTab(i)} style={{
                  padding:"5px 10px",borderRadius:6,fontSize:"0.68rem",fontWeight:600,
                  border:"none",cursor:"pointer",fontFamily:"inherit",minHeight:30,
                  background:tab===i?C.orange:"transparent",
                  color:tab===i?C.white:"rgba(255,255,255,0.4)"}}>
                  {t}
                </button>
              ))}
            </div>
          </div>
          <p style={{margin:0,color:C.white,fontSize:"0.84rem",lineHeight:1.65}}>{summText}</p>
        </div>
      )}

      {w&&(
        <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginBottom:12}}>
          <div style={{fontSize:"0.7rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em",marginBottom:8}}>DISTRICT FORECAST</div>
          <Strip forecast={(function(){var fcs=district.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean);if(!fcs.length)return(w&&w.forecast)||[];return[0,1,2,3,4,5,6].map(function(di){var hs=fcs.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=fcs.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=fcs.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);var ds=fcs.map(function(f){return f[di]&&f[di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);}())}/>
        </div>
      )}


      <input value={q} onChange={e=>setQ(e.target.value)}
        placeholder={"Search "+district.stores.length+" stores..."}
        style={{width:"100%",padding:"10px 13px",borderRadius:10,marginBottom:12,
          border:"1.5px solid "+(q?C.orange:C.border),fontSize:"0.82rem",
          color:C.black,background:C.white,fontFamily:"inherit",outline:"none"}}/>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:10}}>
        {stores.map(s=><Card key={s.num} store={s} district={district} onSelect={onStore}/>)}
      </div>
    </div>
  );
}

function DistRow({district,onClick,onTip}) {
  const w=(function(){
    var liveH=district.stores.map(function(s){return FC[s.num];}).filter(Boolean);
    if(!liveH.length)return null;
    var avgH=Math.round(liveH.map(function(s){return s.high||0;}).reduce(function(a,b){return a+b;},0)/liveH.length);
    var base=liveH[0];
    return {high:avgH,temp:avgH,cond:base.cond,forecast:base.forecast,wind:base.wind||10,humidity:base.humidity||60,precip:base.precip||0};
  }());
  if (!w) return (
    <div style={{animation:"fadeUp 0.25s ease"}}>
      <div style={{background:C.white,borderRadius:14,padding:"32px 18px",border:"1.5px solid "+C.border,textAlign:"center",marginBottom:12}}>
        <div style={{width:28,height:28,borderRadius:"50%",border:"3px solid rgba(249,99,2,0.2)",borderTopColor:C.orange,animation:"spin 0.7s linear infinite",margin:"0 auto 12px"}}/>
        <div style={{fontSize:"0.82rem",color:C.g5,fontWeight:600}}>{"Loading "+district.dm+"..."}</div>
        <div style={{fontSize:"0.65rem",color:C.g4,marginTop:4}}>{district.stores.length+" stores · data incoming"}</div>
      </div>
    </div>
  );
  const alerts  = condPrecip(w.cond);
  const good    = condGood(w.cond)&&w.high>=avg;
  const lyH = district.stores.flatMap(function(s){return(LY[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
  const lyAvg   = lyH.length?Math.round(lyH.reduce(function(a,b){return a+b;},0)/lyH.length):null;
  const delta   = (w.high&&lyAvg)?w.high-lyAvg:null;
  const storeCount = (district.stores&&district.stores.length)||0;
  const rowBg     = alerts?"#FFF5F5":w.high<avg-5?"#FFFDF0":C.white;
  const rowBorder = alerts?C.red:w.high<avg-5?"#E8D84A":C.border;
  const badgeBg   = alerts?C.red:good?C.green:w.high<avg-5?C.od:C.orange;
  const tmrHigh = (function(){var fc=district.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[1]&&FC[s.num].forecast[1].high;}).filter(Boolean);return fc.length?Math.round(fc.reduce(function(a,b){return a+b;},0)/fc.length):w.forecast&&w.forecast[1]&&w.forecast[1].high||null;}());
  const trend   = tmrHigh!=null ? tmrHigh-w.high : null;
  const trendIcon = trend==null?"":trend>=5?"↑↑":trend>=2?"↑":trend>=-2?"→":trend>=-5?"↓":"↓↓";
  const trendColor= trend==null?C.g5:trend>=2?C.green:trend<=-2?C.blue:C.g5;
  // vs LW: avg today vs avg last week for this district's stores
  const lwDelta = (function(){
    var lwH=district.stores.flatMap(function(s){return(LW[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    if(!lwH.length)return null;
    var lwAvg=Math.round(lwH.reduce(function(a,b){return a+b;},0)/lwH.length);
    return w.high-lwAvg;
  }());

  return (
    <button onClick={onClick} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 14px",background:rowBg,border:"1.5px solid "+rowBorder,borderRadius:12,cursor:"pointer",marginBottom:8,fontFamily:"inherit",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",textAlign:"left",WebkitTapHighlightColor:"transparent"}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>

        {/* District badge — color matches row status */}
        <div style={{width:42,height:42,borderRadius:9,background:badgeBg,flexShrink:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:1}}>
          <span style={{fontSize:"0.68rem",fontWeight:800,color:C.white,lineHeight:1}}>{"D"+district.num}</span>
          {/* Enhancement 3: Store count badge */}
          <span style={{fontSize:"0.48rem",color:"rgba(255,255,255,0.75)",fontWeight:600,lineHeight:1}}>{storeCount+" stores"}</span>
        </div>

        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{fontSize:"0.88rem",fontWeight:700,color:C.black,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{district.dm}</div>
            {/* Enhancement 2: Trend arrow */}
            {trend!=null&&<span onClick={function(e){e.stopPropagation();onTip&&onTip({id:"trend",trend:trend,trendIcon:trendIcon,tmrHigh:tmrHigh,trendColor:trendColor});}} style={{fontSize:"0.85rem",fontWeight:800,color:trendColor,flexShrink:0,cursor:"pointer",textDecoration:"underline dotted"}}>{trendIcon}</span>}
          </div>
          <div style={{fontSize:"0.62rem",color:C.g5,marginTop:1}}>{district.region}</div>
          <div style={{display:"flex",gap:5,marginTop:4,flexWrap:"wrap"}}>
            <Chip sm color="gray">{w.high+"°F · "+w.cond}</Chip>
            {trend!=null&&<span onClick={function(e){e.stopPropagation();onTip&&onTip({id:"trend",trend:trend,trendIcon:trendIcon,tmrHigh:tmrHigh,trendColor:trendColor});}} style={{cursor:"pointer"}}><Chip sm color={trend>=2?"green":trend<=-2?"blue":"gray"}>{"Tom: "+(tmrHigh||"—")+"°F"}</Chip></span>}
            {delta!=null&&<Chip sm color={delta>2?"orange":delta<-2?"blue":"gray"}>{(delta>0?"+":"")+delta+"° LY"}</Chip>}
            {lwDelta!=null&&<span onClick={function(e){e.stopPropagation();onTip&&onTip({id:"lw",delta:lwDelta});}} style={{cursor:"pointer"}}><Chip sm color={lwDelta>2?"orange":lwDelta<-2?"blue":"gray"}>{(lwDelta>0?"+":"")+lwDelta+"° LW"}</Chip></span>}
            {(()=>{var fc2=w&&w.forecast||[];var ri=fc2.findIndex(function(f,i){return i>0&&(condPrecip(f.cond)||f.precip>=40);});if(ri>0&&ri<=3){var lbl=ri===1?"Rain tmrw":ri===2?"Rain in 2d":"Rain in 3d";return <span onClick={function(e){e.stopPropagation();onTip&&onTip({id:"rain",rainIdx:ri});}} style={{cursor:"pointer"}}><Chip sm color="blue">{"🌧 "+lbl}</Chip></span>;}return null;})()}
            {alerts&&<Chip sm color="red">⚠ Alert</Chip>}
            {good&&!alerts&&<Chip sm color="green">✓ Good</Chip>}
          </div>
        </div>
      </div>

      <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0,marginLeft:10}}>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:"1.3rem",lineHeight:1}}>{condIcon(w.cond)}</div>
          <div style={{fontSize:"0.78rem",fontWeight:800,color:C.black}}>{w.high}°</div>
        </div>
        <span style={{color:C.g3,fontSize:"1rem"}}>›</span>
      </div>
    </button>
  );
}
function WeekHeatMap({weekIdx, setWeekIdx}) {

  const weekDefs = [
    { label:"Last Week", subtitle:"Last Week", cols: function(d) {
      return [0,1,2,3,4,5,6].map(function(di){var hs=d.stores.map(function(s){return LW[s.num]&&LW[s.num][di]&&LW[s.num][di].high;}).filter(Boolean);var cs=d.stores.map(function(s){return LW[s.num]&&LW[s.num][di]&&LW[s.num][di].cond;}).filter(Boolean);var ds=d.stores.map(function(s){return LW[s.num]&&LW[s.num][di]&&LW[s.num][di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    }},
    { label:"This Week", subtitle:"This Week", cols: function(d) { var fcs=d.stores.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean); if(!fcs.length)return[]; return [0,1,2,3,4,5,6].map(function(di){var hs=fcs.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=fcs.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=fcs.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:fcs[0][di]&&fcs[0][di].day||""}:null;}).filter(Boolean); } },
    { label:"Next Week", subtitle:"Next Week", cols: function(d) {
      return [0,1,2,3,4,5,6].map(function(di){var hs=d.stores.map(function(s){return NW[s.num]&&NW[s.num][di]&&NW[s.num][di].high;}).filter(Boolean);var cs=d.stores.map(function(s){return NW[s.num]&&NW[s.num][di]&&NW[s.num][di].cond;}).filter(Boolean);var ps=d.stores.map(function(s){return NW[s.num]&&NW[s.num][di]&&NW[s.num][di].precip;}).filter(function(x){return x!=null;});var ds=d.stores.map(function(s){return NW[s.num]&&NW[s.num][di]&&NW[s.num][di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    }},
  ];
  const wk = weekDefs[weekIdx];
  const avg = getSeasonal();

  const getColor = (entry, isNextWeek) => {
    if (!entry) return {bg:"#E0E0E0", label:"—"};
    const precipThreshold = isNextWeek ? 60 : 40;
    if (condPrecip(entry.cond) || entry.precip >= precipThreshold) return {bg:"#C62828", label:entry.high+"°"};
    if ((condGood(entry.cond) || entry.high >= avg + 10) && entry.high >= avg) return {bg:"#2E7D32", label:entry.high+"°"};
    if (entry.high >= avg - 5) return {bg:"#F9A825", label:entry.high+"°"};
    return {bg:"#78909C", label:entry.high+"°"};
  };

  return (
    <div style={{background:C.white,borderRadius:12,padding:"14px 16px",
      marginBottom:12,border:"1px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:"0.9rem"}}>📅</span>
          <div>
            <span style={{fontWeight:700,fontSize:"0.82rem",color:C.black}}>Week at a Glance</span>
            <span style={{marginLeft:8,fontSize:"0.65rem",color:C.g5}}>{wk.subtitle}</span>
          </div>
        </div>
        <div style={{display:"flex",gap:10,fontSize:"0.58rem",color:C.g5}}>
          {[{c:"#2E7D32",l:"Good"},{c:"#F9A825",l:"Mixed"},{c:"#78909C",l:"Cold"},{c:"#C62828",l:"Precip"}].map(x=>(
            <span key={x.l} style={{display:"flex",alignItems:"center",gap:3}}>
              <span style={{width:8,height:8,borderRadius:2,background:x.c,display:"inline-block"}}/>
              {x.l}
            </span>
          ))}
        </div>
      </div>

      {/* Week nav */}
      <div style={{display:"flex",gap:4,marginBottom:10,background:C.g1,borderRadius:8,padding:3}}>
        {weekDefs.map((w,i)=>(
          <button key={i} onClick={()=>setWeekIdx(i)} style={{
            flex:1,padding:"5px 8px",borderRadius:6,fontSize:"0.68rem",fontWeight:600,
            border:"none",cursor:"pointer",fontFamily:"inherit",
            background:weekIdx===i?C.orange:"transparent",
            color:weekIdx===i?C.white:C.g5}}>
            {w.label}
          </button>
        ))}
      </div>

      {/* Column headers: derived from actual calendar dates relative to today */}
      {(()=>{
        const DN=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        const today=new Date();
        today.setHours(0,0,0,0);
        // offset: Last Week = -7, This Week = 0, Next Week = +7
        const offsets=[-7,0,7];
        const startOffset=offsets[weekIdx];
        const headers=[0,1,2,3,4,5,6].map(i=>{
          const d=new Date(today);
          d.setDate(today.getDate()+startOffset+i);
          const isToday=weekIdx===1&&i===0;
          return{dayName:DN[d.getDay()],dateNum:d.getDate(),isToday};
        });
        return (
          <div style={{display:"grid",gridTemplateColumns:"72px repeat(7,1fr)",gap:3,marginBottom:10}}>
            <div/>
            {headers.map((h,i)=>(
              <div key={i} style={{textAlign:"center"}}>
                <div style={{fontSize:"0.55rem",fontWeight:600,color:h.isToday?C.orange:C.g5,letterSpacing:"0.03em"}}>{h.dayName}</div>
                <div style={{fontSize:"0.7rem",fontWeight:800,color:h.isToday?C.orange:C.black}}>{h.dateNum}</div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* District rows */}
      {DISTRICTS.map(d => {
        const cols = wk.cols(d);
        return (
          <div key={d.key} style={{display:"grid",gridTemplateColumns:"72px repeat(7,1fr)",gap:3,marginBottom:3}}>
            <div style={{fontSize:"0.6rem",color:C.g5,display:"flex",alignItems:"center",
              overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:4}}>
              {d.dm.split(" ")[1]}
            </div>
            {cols.map((entry,i)=>{
              const col = getColor(entry, weekIdx === 2);
              return (
                <div key={i} style={{background:col.bg,borderRadius:4,padding:"4px 2px",
                  textAlign:"center",fontSize:"0.58rem",fontWeight:700,color:C.white,
                  opacity:weekIdx===1&&i===0?1:0.85}}>
                  {col.label}
                </div>
              );
            })}
          </div>
        );
      })}

      {/* Footer */}
      <div style={{marginTop:8,paddingTop:8,borderTop:"1px solid "+C.border,
        fontSize:"0.62rem",color:C.g5}}>
        {weekIdx===0 && "Last week actuals · Open-Meteo historical data"}
        {weekIdx===1 && "This Week · Open-Meteo ECMWF · refreshes every 30 min"}
        {weekIdx===2 && "Next week extended forecast · Open-Meteo ECMWF"}
      </div>
    </div>
  );
}
function EmailDigest({onClose}) {
  const [copied, setCopied] = useState(false);
  const avg = getSeasonal();
  const allStoresE = DISTRICTS.flatMap(d => d.stores);
  const allHighsE  = allStoresE.map(s => (fhigh(s.num))||0).filter(Boolean);
  const avgHigh    = allHighsE.length ? Math.round(allHighsE.reduce((a,b)=>a+b)/allHighsE.length) : 0;
  const allDeltasE = allStoresE.filter(s=>LY[s.num]&&FC[s.num]).map(s=>{var lyH=(LY[s.num]||[]).map(x=>x.high).filter(Boolean);return lyH.length?fhigh(s.num)-Math.round(lyH.reduce((a,b)=>a+b,0)/lyH.length):null;}).filter(x=>x!=null);
  const rDelta     = allDeltasE.length ? Math.round(allDeltasE.reduce((a,b)=>a+b)/allDeltasE.length) : null;
  const ilDistrictsE = DISTRICTS.filter(d=>d.stores.some(s=>s.state==="IL"||s.state==="IN"));
  const moDistrictsE = DISTRICTS.filter(d=>d.stores.every(s=>s.state==="MO")||d.stores.filter(s=>s.state==="MO").length>d.stores.length/2);
  const lwDeltaIL=(function(){
    var liveH=ilDistrictsE.flatMap(d=>d.stores.map(s=>fhigh(s.num))).filter(Boolean);
    var lwH=ilDistrictsE.flatMap(d=>d.stores.map(s=>LW[s.num]&&LW[s.num][0]&&LW[s.num][0].high)).filter(Boolean);
    if(!liveH.length||!lwH.length)return null;
    return Math.round(liveH.reduce((a,b)=>a+b,0)/liveH.length)-Math.round(lwH.reduce((a,b)=>a+b,0)/lwH.length);
  }());
  const lwDeltaMO=(function(){
    var liveH=moDistrictsE.flatMap(d=>d.stores.map(s=>fhigh(s.num))).filter(Boolean);
    var lwH=moDistrictsE.flatMap(d=>d.stores.map(s=>LW[s.num]&&LW[s.num][0]&&LW[s.num][0].high)).filter(Boolean);
    if(!liveH.length||!lwH.length)return null;
    return Math.round(liveH.reduce((a,b)=>a+b,0)/liveH.length)-Math.round(lwH.reduce((a,b)=>a+b,0)/lwH.length);
  }());
  const lwDelta=lwDeltaIL;
  const dayNames = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const dayScores = [0,1,2,3,4,5,6].map(di=>DISTRICTS.flatMap(d=>d.stores).reduce((total,s)=>{
    const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];if(!f)return total;
    let pts=0;if(condPrecip(f.cond))pts-=2;else pts+=3;if(f.precip>=40)pts-=3;
    if(condGood(f.cond))pts+=2;if(f.high>=avg)pts+=2;if(f.high>=avg+10)pts+=1;return total+pts;
  },0));
  const goodDistrictDays = [0,1,2,3,4,5,6].reduce((total,di)=>total+DISTRICTS.flatMap(d=>d.stores).filter(s=>{const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];return f&&!condPrecip(f.cond)&&f.precip<40&&f.high>=avg;}).length,0);
  const alertLine = ALERTS.length>0?"⚠️ ACTIVE NWS ALERTS: "+ALERTS.map(a=>a.type).join(", ")+"\n":"";
  const goodCount  = DISTRICTS.filter(d=>d.stores.some(s=>FC[s.num]&&condGood(FC[s.num].cond)&&fhigh(s.num)>=avg)).length;
  const alertCount = DISTRICTS.filter(d=>d.stores.some(s=>FC[s.num]&&condPrecip(FC[s.num].cond))).length;

  const emailBody = (() => {
    const dashes = "-".repeat(52);
    const line = (label, val) => "  "+label.padEnd(18)+val;
    const alertSection = ALERTS.length > 0
      ? "ACTIVE NWS ALERTS\n"+dashes+"\n"
        + ALERTS.map(a => "  ⚠ "+a.type+" | "+a.area+" | Until "+a.expires).join("\n")+"\n"
      : "";
    const distSection = DISTRICTS.map(d => {
      const liveH = d.stores.filter(s=>FC_LIVE.has(s.num)).map(s=>fhigh(s.num)).filter(Boolean);
      if (!liveH.length) return "";
      const allFC = d.stores.map(s=>FC[s.num]&&FC[s.num].forecast).filter(Boolean);
      const forecast = allFC.length ? [0,1,2,3,4,5,6].map(di=>{
        const hs=allFC.map(f=>f[di]&&f[di].high).filter(Boolean);
        const ps=allFC.map(f=>f[di]&&f[di].precip).filter(x=>x!=null);
        const cs=allFC.map(f=>f[di]&&f[di].cond).filter(Boolean);
        const ds=allFC.map(f=>f[di]&&f[di].day).filter(Boolean);
        return hs.length?{high:Math.round(hs.reduce((a,b)=>a+b,0)/hs.length),precip:ps.length?Math.round(ps.reduce((a,b)=>a+b,0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;
      }).filter(Boolean) : [];
      const lwHighs = d.stores.flatMap(s=>(LW[s.num]||[]).map(x=>x.high)).filter(Boolean);
      const lyHighs = d.stores.flatMap(s=>(LY[s.num]||[]).map(x=>x.high)).filter(Boolean);
      const nwHighs = d.stores.flatMap(s=>(NW[s.num]||[]).map(x=>x.high)).filter(Boolean);
      const ds2 = buildSummary({highs:liveH,forecast,lwHighs,lyHighs,nwHighs,storeCount:d.stores.length,label:"D"+d.num+" "+d.dm});
      return "D"+d.num+" "+d.dm+" | "+d.region+"\n"
        + (ds2&&ds2.today ? "  "+ds2.today+"\n" : "")
        + (ds2&&ds2.week  ? "  "+ds2.week       : "");
    }).filter(Boolean).join("\n\n");

    const bestDayName = dayNames[dayScores.indexOf(Math.max(...dayScores))];
    const weekPct     = Math.round(goodDistrictDays/(DISTRICTS.flatMap(d=>d.stores).length*7)*100);
    const emailAllSt = DISTRICTS.flatMap(d=>d.stores);
    const emailLiveH = emailAllSt.filter(s=>FC_LIVE.has(s.num)).map(s=>fhigh(s.num)).filter(Boolean);
    const emailAllFC = emailAllSt.map(s=>FC[s.num]&&FC[s.num].forecast).filter(Boolean);
    const emailForecast = emailAllFC.length ? [0,1,2,3,4,5,6].map(di=>{
      const hs=emailAllFC.map(f=>f[di]&&f[di].high).filter(Boolean);
      const ps=emailAllFC.map(f=>f[di]&&f[di].precip).filter(x=>x!=null);
      const cs=emailAllFC.map(f=>f[di]&&f[di].cond).filter(Boolean);
      const ds=emailAllFC.map(f=>f[di]&&f[di].day).filter(Boolean);
      return hs.length?{high:Math.round(hs.reduce((a,b)=>a+b,0)/hs.length),precip:ps.length?Math.round(ps.reduce((a,b)=>a+b,0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;
    }).filter(Boolean) : [];
    const emailLWH = emailAllSt.flatMap(s=>(LW[s.num]||[]).map(x=>x.high)).filter(Boolean);
    const emailLYH = emailAllSt.flatMap(s=>(LY[s.num]||[]).map(x=>x.high)).filter(Boolean);
    const emailNWH = emailAllSt.flatMap(s=>(NW[s.num]||[]).map(x=>x.high)).filter(Boolean);
    const emailSumm = emailLiveH.length ? buildSummary({highs:emailLiveH,forecast:emailForecast,lwHighs:emailLWH,lyHighs:emailLYH,nwHighs:emailNWH,storeCount:102,label:"Central Region"}) : null;

    return (
"Hamad Central Weather Digest\n"
+dashes+"\n"
+DATA_DATE+" | "+DATA_SOURCE+"\n"
+dashes+"\n\n"
+(alertSection ? alertSection+"\n" : "")
+"REGION SNAPSHOT\n"
+dashes+"\n"
+line("Avg High Today:", avgHigh+"°F  (seasonal avg "+avg+"°F)")+"\n"
+line("vs Last Week:", (lwDeltaIL!=null?"IL "+(lwDeltaIL>0?"+":"")+lwDeltaIL+"°":"—")+" | MO "+(lwDeltaMO!=null?(lwDeltaMO>0?"+":"")+lwDeltaMO+"°":"—")+" ("+LAST_WEEK_DATE+")")+"\n"
+line("vs Last Year:", rDelta!=null?(rDelta>0?"+":"")+rDelta+"°":"—")+"\n"
+line("Best Day:", bestDayName+" ("+Math.max(...dayScores)+"/10 districts favorable)")+"\n"
+line("Good Week:", weekPct+"% of district-days favorable")+"\n"
+(emailSumm&&emailSumm.today ? "\n"+emailSumm.today+"\n" : "")
+(emailSumm&&emailSumm.week  ? emailSumm.week+"\n"       : "")
+(emailSumm&&emailSumm.nextWeek ? emailSumm.nextWeek+"\n" : "")
+"\n"
+"BY DISTRICT\n"
+dashes+"\n"
+distSection+"\n"
+"\n"
+dashes+"\n"
+"Questions? Reply to this email."
    );
  })()

  const copy = () => {
    navigator.clipboard.writeText(emailBody).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }).catch(() => {
      const el = document.createElement("textarea");
      el.value = emailBody;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",
      zIndex:999,display:"flex",alignItems:"flex-start",justifyContent:"center",
      padding:"20px 12px",overflowY:"auto"}}>
      <div style={{background:C.white,borderRadius:14,width:"100%",maxWidth:600,
        boxShadow:"0 8px 32px rgba(0,0,0,0.3)"}}>
        <div style={{background:C.orange,padding:"14px 16px",borderRadius:"14px 14px 0 0",
          display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:"1rem"}}>📧</span>
            <span style={{fontWeight:800,fontSize:"0.9rem",color:C.white}}>Email Digest</span>
            <span style={{fontSize:"0.62rem",color:"rgba(255,255,255,0.7)"}}>
              {DATA_DATE}
            </span>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.2)",border:"none",
            borderRadius:20,padding:"4px 10px",color:C.white,cursor:"pointer",
            fontFamily:"inherit",fontSize:"0.8rem",fontWeight:700}}>
            ✕
          </button>
        </div>
        <div style={{padding:"14px 16px"}}>
          <div style={{fontSize:"0.72rem",color:C.g5,marginBottom:8}}>
            Copy this text and paste into an email to your DMs:
          </div>
          <pre style={{background:C.g1,border:"1px solid "+C.border,borderRadius:8,
            padding:"12px",fontSize:"0.68rem",color:C.black,overflowX:"auto",
            whiteSpace:"pre-wrap",maxHeight:320,overflowY:"auto",
            fontFamily:"monospace",lineHeight:1.6}}>
            {emailBody}
          </pre>
          <button onClick={copy} style={{marginTop:12,width:"100%",padding:"11px",
            borderRadius:9,background:copied?C.green:C.orange,color:C.white,
            border:"none",fontWeight:700,fontSize:"0.82rem",cursor:"pointer",
            fontFamily:"inherit",transition:"background 0.2s"}}>
            {copied ? "✓ Copied!" : "📋 Copy to Clipboard"}
          </button>
        </div>
      </div>
    </div>
  );
}


export default function App() {
  const [nav,setNav]=useState({view:"home"});
  const [showEmail,setShowEmail]=useState(false);
  const [historyMode,setHistoryMode]=useState(null);
  const [tooltipPill,setTooltipPill]=useState(null);
  const [fState,setFState]=useState("all");
  const [fCond,setFCond]=useState("all");
  const [search,setSearch]=useState("");
  const [showF,setShowF]=useState(false);
  const [showAlerts,setShowAlerts]=useState(null);
  const [showRadar,setShowRadar]=useState(false);
  const [showRanking,setShowRanking]=useState(false);
  const [showEmailModal,setShowEmailModal]=useState(false);

  const allStores=DISTRICTS.flatMap(d=>d.stores);
  const [_ldn, _setLdn] = useState(0);
  const [_ldg, _setLdg] = useState(false);

  // ── Fetch 1: Open-Meteo ECMWF — current conditions + this week + next week ──
  // ECMWF IFS is the gold standard for 1-14 day forecasts, free, no key needed
  useEffect(function() {
    var nums=Object.keys(STORE_COORDS);
    var done=0;
    _setLdg(true);
    var DN=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    var wmo=function(c){
      if(c<=0)return"Sunny";
      if(c<=1)return"Sunny";
      if(c<=2)return"Partly Cloudy";
      if(c<=3)return"Cloudy";
      if(c<=45)return"Foggy";
      if(c<=48)return"Foggy";
      if(c<=55)return"Rain";
      if(c<=57)return"Rain";
      if(c<=61)return"Rain";
      if(c<=65)return"Rain";
      if(c<=67)return"Rain";
      if(c<=71)return"Snow";
      if(c<=75)return"Snow";
      if(c<=77)return"Snow";
      if(c<=82)return"Rain";
      if(c<=86)return"Snow";
      if(c<=99)return"Thunderstorm";
      return"Partly Cloudy";
    };
    var idx=0;
    var run=function(){
      if(idx>=nums.length){return;}
      var n=nums[idx++];
      var c=STORE_COORDS[n];
      var url="https://api.open-meteo.com/v1/forecast?latitude="+c[0]+"&longitude="+c[1]
        +"&daily=temperature_2m_max,temperature_2m_min,precipitation_probability_max,weather_code"
        +"&temperature_unit=fahrenheit&timezone=America%2FChicago&forecast_days=14&models=ecmwf_ifs025";
      fetch(url).then(function(r){return r.json();}).then(function(d){
        if(!d.daily||!d.daily.time){done++;_setLdn(done);setTimeout(run,60);return;}
        var days=d.daily.time;
        var maxT=d.daily.temperature_2m_max;
        var minT=d.daily.temperature_2m_min;
        var wc=d.daily.weather_code;
        var pp=d.daily.precipitation_probability_max;
        // This week: days 0-6
        var forecast=days.slice(0,7).map(function(t,i){
          var dt=new Date(t+"T12:00:00");
          return{day:i===0?"Today":DN[dt.getDay()],high:Math.round(maxT[i]),low:minT?Math.round(minT[i]):null,cond:wmo(wc?wc[i]:0),precip:pp?Math.round(pp[i]):0};
        });
        // Next week: days 7-13
        var nwDays=days.slice(7,14);
        if(nwDays.length){
          NW[n]=nwDays.map(function(t,i){
            var gi=i+7;
            var dt=new Date(t+"T12:00:00");
            return{day:DN[dt.getDay()],high:Math.round(maxT[gi]),low:minT?Math.round(minT[gi]):null,cond:wmo(wc?wc[gi]:0),precip:pp?Math.round(pp[gi]):0};
          });
        }
        FC_LIVE.add(n);
        FC[n]={
          temp:Math.round(maxT[0]),
          high:Math.round(maxT[0]),
          low:minT?Math.round(minT[0]):null,
          cond:wmo(wc?wc[0]:0),
          precip:pp?Math.round(pp[0]):0,
          feels:Math.round(maxT[0]),
          wind:10,humidity:60,
          forecast:forecast
        };
        done++;_setLdn(done);
        if(done>=nums.length)_setLdg(false);
        setTimeout(run,60);
      }).catch(function(){done++;_setLdn(done);if(done>=nums.length)_setLdg(false);setTimeout(run,60);});
    };
    // Start 4 parallel chains to speed up loading
    for(var i=0;i<4;i++) setTimeout(run, i*15);
    var id=setInterval(function(){
      idx=0;done=0;_setLdg(true);
      for(var i=0;i<4;i++) setTimeout(run,i*15);
    },1800000);
    return function(){clearInterval(id);};
  },[]);

  // ── Fetch 2: Open-Meteo archive — last week + last year actuals per store ──
  useEffect(function(){
    var fmt=function(d){return d.toISOString().split("T")[0];};
    var DN=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    var wmo=function(c){return c<=1?"Sunny":c===2?"Partly Cloudy":c===3?"Cloudy":c>=51&&c<=67?"Rain":c>=71&&c<=77?"Snow":c>=80&&c<=82?"Rain":c>=95?"Thunderstorm":"Partly Cloudy";};
    var lwEnd=new Date();lwEnd.setDate(lwEnd.getDate()-1);
    var lwStart=new Date(lwEnd);lwStart.setDate(lwEnd.getDate()-6);
    var lyEnd=new Date(lwEnd);lyEnd.setFullYear(lyEnd.getFullYear()-1);
    var lyStart=new Date(lwStart);lyStart.setFullYear(lwStart.getFullYear()-1);
    var nums=Object.keys(STORE_COORDS);
    var idx=0;
    var omDone=0;
    var runNext=function(){
      if(idx>=nums.length)return;
      var n=nums[idx++];
      var c=STORE_COORDS[n];
      var base="https://archive-api.open-meteo.com/v1/archive?latitude="+c[0]+"&longitude="+c[1]+"&daily=temperature_2m_max,weather_code&temperature_unit=fahrenheit&timezone=America%2FChicago";
      // LW + LY from Open-Meteo archive — actuals only
      fetch(base+"&start_date="+fmt(lwStart)+"&end_date="+fmt(lwEnd)).then(function(r){return r.json();}).then(function(d){
        if(d.daily&&d.daily.time){LW[n]=d.daily.time.map(function(t,i){return{day:DN[new Date(t+"T12:00:00").getDay()],high:Math.round(d.daily.temperature_2m_max[i]),cond:wmo(d.daily.weather_code?d.daily.weather_code[i]:0)};});}
      }).catch(function(){});
      fetch(base+"&start_date="+fmt(lyStart)+"&end_date="+fmt(lyEnd)).then(function(r){return r.json();}).then(function(d){
        if(d.daily&&d.daily.time){LY[n]=d.daily.time.map(function(t,i){return{day:DN[new Date(t+"T12:00:00").getDay()],high:Math.round(d.daily.temperature_2m_max[i]),cond:wmo(d.daily.weather_code?d.daily.weather_code[i]:0)};});}
      }).catch(function(){});
      setTimeout(runNext,80);
    };
    runNext();
  },[]);
  useEffect(()=>{window.scrollTo(0,0);},[nav]);

  const alerts=allStores.filter(s=>FC[s.num]&&condPrecip(FC[s.num].cond)).length;
  const good=allStores.filter(s=>FC[s.num]&&condGood(FC[s.num].cond)&&fhigh(s.num)>=avg).length;
  const allHighs=allStores.map(s=>(fhigh(s.num))||0).filter(Boolean);
  const avgHigh=allHighs.length?Math.round(allHighs.reduce((a,b)=>a+b)/allHighs.length):0;
  // vs LY: compare each live store's today high vs that store's LY avg
  const allDeltas=allStores.filter(s=>LY[s.num]&&FC[s.num]).map(s=>{var lyH=(LY[s.num]||[]).map(x=>x.high).filter(Boolean);return lyH.length?fhigh(s.num)-Math.round(lyH.reduce((a,b)=>a+b,0)/lyH.length):null;}).filter(x=>x!=null);
  const rDelta=allDeltas.length?Math.round(allDeltas.reduce((a,b)=>a+b)/allDeltas.length):null;
  const lwDelta=null; // legacy compat — computed per region below
  const ilDistricts = DISTRICTS.filter(d=>d.stores.some(s=>s.state==="IL"||s.state==="IN"));
  const moDistricts = DISTRICTS.filter(d=>d.stores.every(s=>s.state==="MO")||d.stores.filter(s=>s.state==="MO").length>d.stores.length/2);
  const lwDeltaIL=(function(){
    var liveH=ilDistricts.flatMap(function(d){return d.stores.map(function(s){return fhigh(s.num);});}).filter(Boolean);
    // Compare today vs same day last week (LW[0] = exactly 7 days ago)
    var lwH=ilDistricts.flatMap(function(d){return d.stores.map(function(s){return LW[s.num]&&LW[s.num][0]&&LW[s.num][0].high;});}).filter(Boolean);
    if(!liveH.length||!lwH.length)return null;
    return Math.round(liveH.reduce(function(a,b){return a+b;},0)/liveH.length)-Math.round(lwH.reduce(function(a,b){return a+b;},0)/lwH.length);
  }());
  const lwDeltaMO=(function(){
    var liveH=moDistricts.flatMap(function(d){return d.stores.map(function(s){return fhigh(s.num);});}).filter(Boolean);
    var lwH=moDistricts.flatMap(function(d){return d.stores.map(function(s){return LW[s.num]&&LW[s.num][0]&&LW[s.num][0].high;});}).filter(Boolean);
    if(!liveH.length||!lwH.length)return null;
    return Math.round(liveH.reduce(function(a,b){return a+b;},0)/liveH.length)-Math.round(lwH.reduce(function(a,b){return a+b;},0)/lwH.length);
  }());

  const ilHighs=ilDistricts.map(function(d){var lh=d.stores.filter(function(s){return FC_LIVE.has(s.num);}).map(function(s){return fhigh(s.num);}).filter(Boolean);return lh.length?Math.round(lh.reduce(function(a,b){return a+b;},0)/lh.length):null;}).filter(Boolean);
  const moHighs=moDistricts.map(function(d){var lh=d.stores.filter(function(s){return FC_LIVE.has(s.num);}).map(function(s){return fhigh(s.num);}).filter(Boolean);return lh.length?Math.round(lh.reduce(function(a,b){return a+b;},0)/lh.length):null;}).filter(Boolean);
  const ilAvgHigh = ilHighs.length ? Math.round(ilHighs.reduce((a,b)=>a+b)/ilHighs.length) : null;
  const moAvgHigh = moHighs.length ? Math.round(moHighs.reduce((a,b)=>a+b)/moHighs.length) : null;

  const ilAlerts = ilDistricts.flatMap(d=>d.stores).filter(s=>FC[s.num]&&condPrecip(FC[s.num].cond)).length;
  const moAlerts = moDistricts.flatMap(d=>d.stores).filter(s=>FC[s.num]&&condPrecip(FC[s.num].cond)).length;

  // VS LY: today's high vs same date last year (LY[0] = exactly 1 year ago today)
  const ilRDeltas = ilDistricts.flatMap(function(d){return d.stores.map(function(s){var lh=fhigh(s.num);var lyDay=LY[s.num]&&LY[s.num][0]&&LY[s.num][0].high;if(!lh||!lyDay)return null;return lh-lyDay;});}).filter(function(x){return x!=null;});
  const moRDeltas = moDistricts.flatMap(function(d){return d.stores.map(function(s){var lh=fhigh(s.num);var lyDay=LY[s.num]&&LY[s.num][0]&&LY[s.num][0].high;if(!lh||!lyDay)return null;return lh-lyDay;});}).filter(function(x){return x!=null;});
  const ilRDelta = ilRDeltas.length?Math.round(ilRDeltas.reduce((a,b)=>a+b)/ilRDeltas.length):null;
  const moRDelta = moRDeltas.length?Math.round(moRDeltas.reduce((a,b)=>a+b)/moRDeltas.length):null;

  // Best day scores from live per-store FC
  const scoreForecastDay=(districts,di)=>districts.flatMap(d=>d.stores).reduce((t,s)=>{const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];if(!f)return t;let p=0;if(condPrecip(f.cond))p-=2;else p+=3;if(f.precip>=40)p-=3;if(condGood(f.cond))p+=2;if(f.high>=avg)p+=2;if(f.high>=avg+10)p+=1;return t+p;},0);
  const ilScores=[0,1,2,3,4,5,6].map(di=>scoreForecastDay(ilDistricts,di));
  const moScores=[0,1,2,3,4,5,6].map(di=>scoreForecastDay(moDistricts,di));
  const ilBestIdx=ilScores.indexOf(Math.max(...ilScores));
  const moBestIdx=moScores.indexOf(Math.max(...moScores));
  var _twMon=new Date();_twMon.setDate(_twMon.getDate()-((_twMon.getDay()||7)-1));const thisWeekDates=Array.from({length:7},function(_,i){var d=new Date(_twMon);d.setDate(_twMon.getDate()+i);return d.getDate();});
  const nextWeekDates=Array.from({length:7},function(_,i){var d=new Date(_twMon);d.setDate(_twMon.getDate()+7+i);return d.getDate();});
  // Next week best day from per-store NW
  const scoreNWDay=(districts,di)=>districts.flatMap(d=>d.stores).reduce((t,s)=>{const f=NW[s.num]&&NW[s.num][di];if(!f)return t;let p=0;if(condPrecip(f.cond))p-=2;else p+=3;if(f.precip>=40)p-=3;if(condGood(f.cond))p+=2;if(f.high>=avg)p+=2;if(f.high>=avg+10)p+=1;return t+p;},0);
  const ilNwScores=[0,1,2,3,4,5,6].map(di=>scoreNWDay(ilDistricts,di));
  const ilNwBestIdx=ilNwScores.indexOf(Math.max(...ilNwScores));
  const moNwScores=[0,1,2,3,4,5,6].map(di=>scoreNWDay(moDistricts,di));
  const moNwBestIdx=moNwScores.indexOf(Math.max(...moNwScores));

  // Weekend score from live FC
  const calcWkndScore=function(dists){var r=dists.flatMap(function(d){return d.stores;}).reduce(function(acc,s){var w=FC[s.num];if(!w)return acc;[0,1].forEach(function(di){var f=w.forecast&&w.forecast[di];if(!f)return;var sc=0;sc+=Math.min(4,Math.max(0,Math.round((f.high-avg)/8+2)));if(!condPrecip(f.cond)&&f.precip<20)sc+=3;else if(!condPrecip(f.cond)&&f.precip<40)sc+=1;if(condGood(f.cond))sc+=3;else if(f.cond==="Partly Cloudy"||f.cond==="Mostly Cloudy")sc+=1;if(condPrecip(f.cond))sc-=3;if(f.precip>=40)sc-=2;acc.t+=Math.min(10,Math.max(0,sc));acc.c++;});return acc;},{t:0,c:0});return r.c?Math.min(10,Math.round(r.t/r.c)):0;};
  const ilWkndScore=calcWkndScore(ilDistricts);
  const moWkndScore=calcWkndScore(moDistricts);
  const wkndColor=function(s){return s>=7?C.green:s>=4?C.od:C.red;};

  // Good days from live FC
  const ilGoodDays=[0,1,2,3,4,5,6].reduce((t,di)=>t+ilDistricts.flatMap(d=>d.stores).filter(s=>{const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];return f&&!condPrecip(f.cond)&&f.precip<40&&f.high>=avg;}).length,0);
  const moGoodDays=[0,1,2,3,4,5,6].reduce((t,di)=>t+moDistricts.flatMap(d=>d.stores).filter(s=>{const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];return f&&!condPrecip(f.cond)&&f.precip<40&&f.high>=avg;}).length,0);
  const ilTotalStoreDays=ilDistricts.flatMap(d=>d.stores).length*7;
  const moTotalStoreDays=moDistricts.flatMap(d=>d.stores).length*7;
  const ilGoodPct = ilTotalStoreDays>0?Math.round(ilGoodDays/ilTotalStoreDays*100):0;
  const moGoodPct = moTotalStoreDays>0?Math.round(moGoodDays/moTotalStoreDays*100):0;

  // ── Week toggle (lifted from WeekHeatMap so pills stay in sync) ──
  const [weekIdx, setWeekIdx] = useState(1); // 0=Last, 1=This, 2=Next
  const weekLabels = ["Last Week", "This Week", "Next Week"];

  // Helper: get a strip of 7 day-entries for a district for a given weekIdx — all per-store, no anchors
  const getStrip = (d, wi) => {
    if (wi === 0) {
      return [0,1,2,3,4,5,6].map(di=>{var hs=d.stores.map(s=>LW[s.num]&&LW[s.num][di]&&LW[s.num][di].high).filter(Boolean);var cs=d.stores.map(s=>LW[s.num]&&LW[s.num][di]&&LW[s.num][di].cond).filter(Boolean);var ds=d.stores.map(s=>LW[s.num]&&LW[s.num][di]&&LW[s.num][di].day).filter(Boolean);return hs.length?{high:Math.round(hs.reduce((a,b)=>a+b,0)/hs.length),precip:0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    }
    if (wi === 2) {
      return [0,1,2,3,4,5,6].map(di=>{var hs=d.stores.map(s=>NW[s.num]&&NW[s.num][di]&&NW[s.num][di].high).filter(Boolean);var cs=d.stores.map(s=>NW[s.num]&&NW[s.num][di]&&NW[s.num][di].cond).filter(Boolean);var ps=d.stores.map(s=>NW[s.num]&&NW[s.num][di]&&NW[s.num][di].precip).filter(x=>x!=null);var ds=d.stores.map(s=>NW[s.num]&&NW[s.num][di]&&NW[s.num][di].day).filter(Boolean);return hs.length?{high:Math.round(hs.reduce((a,b)=>a+b,0)/hs.length),precip:ps.length?Math.round(ps.reduce((a,b)=>a+b,0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    }
    var fcs = d.stores.map(s => FC[s.num] && FC[s.num].forecast).filter(Boolean);
    if (!fcs.length) return [];
    return [0,1,2,3,4,5,6].map(di => {
      var hs = fcs.map(f => f[di] && f[di].high).filter(Boolean);
      var ps = fcs.map(f => f[di] && f[di].precip).filter(x => x != null);
      var cs = fcs.map(f => f[di] && f[di].cond).filter(Boolean);
      var ds = fcs.map(f => f[di] && f[di].day).filter(Boolean);
      return hs.length ? {high: Math.round(hs.reduce((a,b)=>a+b,0)/hs.length), precip: ps.length ? Math.round(ps.reduce((a,b)=>a+b,0)/ps.length) : 0, cond: cs[0] || "Partly Cloudy", day: ds[0] || ""} : null;
    }).filter(Boolean);
  };

  // Compute pill values per weekIdx
  const pillVals = (function(wi) {
    var scoreStrip = (districts, strip) => [0,1,2,3,4,5,6].map(di => districts.reduce((t,d) => {
      var f = strip(d)[di]; if (!f) return t;
      var p = 0;
      if (condPrecip(f.cond)) p -= 2; else p += 3;
      if (f.precip >= 40) p -= 3;
      if (condGood(f.cond)) p += 2;
      if (f.high >= avg) p += 2;
      if (f.high >= avg + 10) p += 1;
      return t + p;
    }, 0));
    var ilScores = scoreStrip(ilDistricts, d => getStrip(d, wi));
    var moScores = scoreStrip(moDistricts, d => getStrip(d, wi));
    var ilBI = ilScores.indexOf(Math.max(...ilScores));
    var moBI = moScores.indexOf(Math.max(...moScores));

    // Avg high: for This Week use today (index 0), for Last/Next use mid-week (index 3)
    var refIdx = wi === 1 ? 0 : 3;
    var ilAllH = ilDistricts.flatMap(d => { var strip = getStrip(d, wi); return strip[refIdx] ? [strip[refIdx].high] : []; }).filter(Boolean);
    var moAllH = moDistricts.flatMap(d => { var strip = getStrip(d, wi); return strip[refIdx] ? [strip[refIdx].high] : []; }).filter(Boolean);
    var ilAvg2 = wi === 1 ? ilAvgHigh : (ilAllH.length ? Math.round(ilAllH.reduce((a,b)=>a+b,0)/ilAllH.length) : null);
    var moAvg2 = wi === 1 ? moAvgHigh : (moAllH.length ? Math.round(moAllH.reduce((a,b)=>a+b,0)/moAllH.length) : null);

    var ilGD = [0,1,2,3,4,5,6].reduce((t,di) => t + ilDistricts.filter(d => { var f = getStrip(d,wi)[di]; return f && !condPrecip(f.cond) && f.precip < 40 && f.high >= avg; }).length, 0);
    var moGD = [0,1,2,3,4,5,6].reduce((t,di) => t + moDistricts.filter(d => { var f = getStrip(d,wi)[di]; return f && !condPrecip(f.cond) && f.precip < 40 && f.high >= avg; }).length, 0);
    var ilGP = Math.round(ilGD / (ilDistricts.length * 7) * 100);
    var moGP = Math.round(moGD / (moDistricts.length * 7) * 100);

    // Weekend: first 2 entries in strip (index 0-1 for Last/Next; or forecast[0-1] for This)
    var calcWknd = (districts) => {
      var r = districts.reduce((acc, d) => {
        var strip = getStrip(d, wi);
        [0,1].forEach(di => {
          var f = strip[di]; if (!f) return;
          var s = 0;
          s += Math.min(4, Math.max(0, Math.round((f.high - avg) / 8 + 2)));
          if (!condPrecip(f.cond) && f.precip < 20) s += 3;
          else if (!condPrecip(f.cond) && f.precip < 40) s += 1;
          if (condGood(f.cond)) s += 3;
          else if (f.cond === "Partly Cloudy" || f.cond === "Mostly Cloudy") s += 1;
          if (condPrecip(f.cond)) s -= 3;
          if (f.precip >= 40) s -= 2;
          acc.t += Math.min(10, Math.max(0, s)); acc.c++;
        });
        return acc;
      }, {t:0, c:0});
      return r.c ? Math.min(10, Math.round(r.t / r.c)) : 0;
    };
    var ilWS = calcWknd(ilDistricts);
    var moWS = calcWknd(moDistricts);

    // Best day label using strip day names
    var dayNames2 = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    var ilBestLabel = (function() {
      var f = getStrip(ilDistricts[0] || ilDistricts[0], wi)[ilBI];
      if (!f) return dayNames2[ilBI] || "—";
      return f.day || dayNames2[ilBI] || "—";
    })();
    var moBestLabel = (function() {
      var f = getStrip(moDistricts[0] || moDistricts[0], wi)[moBI];
      if (!f) return dayNames2[moBI] || "—";
      return f.day || dayNames2[moBI] || "—";
    })();

    // vs LW / vs LY for each weekIdx context
    var ilVsLW = null, moVsLW = null, ilVsLY = null, moVsLY = null;
    if (wi === 1) { ilVsLW = lwDeltaIL; moVsLW = lwDeltaMO; ilVsLY = ilRDelta; moVsLY = moRDelta; }
    else if (wi === 0) {
      var ilLWH = ilDistricts.flatMap(d=>d.stores.flatMap(s=>(LW[s.num]||[]).map(e=>e.high))).filter(Boolean);
      var ilLYH = ilDistricts.flatMap(d=>d.stores.flatMap(s=>(LY[s.num]||[]).map(e=>e.high))).filter(Boolean);
      var moLWH = moDistricts.flatMap(d=>d.stores.flatMap(s=>(LW[s.num]||[]).map(e=>e.high))).filter(Boolean);
      var moLYH = moDistricts.flatMap(d=>d.stores.flatMap(s=>(LY[s.num]||[]).map(e=>e.high))).filter(Boolean);
      ilVsLY = (ilLWH.length && ilLYH.length) ? Math.round(ilLWH.reduce((a,b)=>a+b,0)/ilLWH.length) - Math.round(ilLYH.reduce((a,b)=>a+b,0)/ilLYH.length) : null;
      moVsLY = (moLWH.length && moLYH.length) ? Math.round(moLWH.reduce((a,b)=>a+b,0)/moLWH.length) - Math.round(moLYH.reduce((a,b)=>a+b,0)/moLYH.length) : null;
      ilVsLW = null; moVsLW = null;
    } else if (wi === 2) {
      var ilTWH = ilDistricts.flatMap(d=>d.stores.map(s=>fhigh(s.num))).filter(Boolean);
      var ilNWH = ilDistricts.flatMap(d=>d.stores.flatMap(s=>(NW[s.num]||[]).map(e=>e.high))).filter(Boolean);
      var moTWH = moDistricts.flatMap(d=>d.stores.map(s=>fhigh(s.num))).filter(Boolean);
      var moNWH = moDistricts.flatMap(d=>d.stores.flatMap(s=>(NW[s.num]||[]).map(e=>e.high))).filter(Boolean);
      ilVsLW = (ilNWH.length && ilTWH.length) ? Math.round(ilNWH.reduce((a,b)=>a+b,0)/ilNWH.length) - Math.round(ilTWH.reduce((a,b)=>a+b,0)/ilTWH.length) : null;
      moVsLW = (moNWH.length && moTWH.length) ? Math.round(moNWH.reduce((a,b)=>a+b,0)/moNWH.length) - Math.round(moTWH.reduce((a,b)=>a+b,0)/moTWH.length) : null;
      ilVsLY = ilRDelta; moVsLY = moRDelta;
    }

    return { ilAvg: ilAvg2, moAvg: moAvg2, ilBI, moBI, ilBestLabel, moBestLabel, ilWS, moWS, ilGP, moGP, ilVsLW, moVsLW, ilVsLY, moVsLY };
  })(weekIdx);
  const wkndColor2 = s => s >= 7 ? C.green : s >= 4 ? C.od : C.red;
  const vsLabel = weekIdx === 0 ? "vs LY" : weekIdx === 2 ? "vs TW" : "vs LW";
  const vsLYLabel = "vs LY";
  // dayScores and goodDistrictDays from live per-store FC
  const dayScores=[0,1,2,3,4,5,6].map(di=>DISTRICTS.flatMap(d=>d.stores).reduce((total,s)=>{
    const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];
    if(!f)return total;let pts=0;
    if(condPrecip(f.cond))pts-=2;else pts+=3;
    if(f.precip>=40)pts-=3;if(condGood(f.cond))pts+=2;
    if(f.high>=avg)pts+=2;if(f.high>=avg+10)pts+=1;
    return total+pts;
  },0));
  const bestDayIdx=dayScores.indexOf(Math.max(...dayScores));
  const dayNames=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const bestDay=dayNames[bestDayIdx]+"("+Math.max(...dayScores)+")";
  const goodDistrictDays=[0,1,2,3,4,5,6].reduce((total,di)=>total+DISTRICTS.flatMap(d=>d.stores).filter(s=>{const f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];return f&&!condPrecip(f.cond)&&f.precip<40&&f.high>=avg;}).length, 0);
  const today=new Date().toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});

  // ── Feature: Precip window countdown ──
  // Find next day index (0=today) where ≥40% of stores have precip
  const precipCountdown=(function(){
    var DN2=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    for(var di=0;di<7;di++){
      var stores=allStores.filter(function(s){var f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];return f&&(condPrecip(f.cond)||f.precip>=40);});
      if(stores.length>=Math.round(allStores.length*0.3)){
        var d2=new Date();d2.setDate(d2.getDate()+di);
        var avgPrecip=Math.round(stores.map(function(s){return FC[s.num].forecast[di].precip;}).reduce(function(a,b){return a+b;},0)/stores.length);
        return{daysAway:di,dayName:di===0?"Today":di===1?"Tomorrow":DN2[d2.getDay()],storeCount:stores.length,avgPrecip:avgPrecip};
      }
    }
    return null;
  }());

  // ── Feature: District ranking by weather score this week ──
  const districtRanking=(function(){
    return DISTRICTS.map(function(d){
      var score=0;var count=0;
      d.stores.forEach(function(s){
        var fc=FC[s.num]&&FC[s.num].forecast;
        if(!fc)return;
        [0,1,2,3,4,5,6].forEach(function(di){
          var f=fc[di];if(!f)return;
          var pts=0;
          if(!condPrecip(f.cond)&&f.precip<40)pts+=3;
          if(condGood(f.cond))pts+=2;
          if(f.high>=avg)pts+=2;
          if(f.high>=avg+8)pts+=1;
          if(condPrecip(f.cond))pts-=3;
          score+=pts;count++;
        });
      });
      var h=d.stores.map(function(s){return fhigh(s.num);}).filter(Boolean);
      var avgH=h.length?Math.round(h.reduce(function(a,b){return a+b;},0)/h.length):0;
      var rainToday=d.stores.filter(function(s){return FC[s.num]&&condPrecip(FC[s.num].cond);}).length;
      return{key:d.key,dm:d.dm,num:d.num,region:d.region,score:count?Math.round(score/count*10)/10:0,avgH:avgH,rainToday:rainToday,stores:d.stores.length};
    }).sort(function(a,b){return b.score-a.score;});
  }());

  const homeDists=DISTRICTS.map(d=>({...d,stores:d.stores.filter(s=>{
    if(fState!=="all"&&s.state!==fState)return false;
    if(search){const q=search.toLowerCase();if(!s.name.toLowerCase().includes(q)&&!s.num.includes(q)&&!d.dm.toLowerCase().includes(q))return false;}
    if(fCond!=="all"&&FC[s.num]){
      if(fCond==="alerts"&&!condPrecip(FC[s.num].cond))return false;
      if(fCond==="good"&&!(condGood(FC[s.num].cond)&&fhigh(s.num)>=avg))return false;
    }
    return true;
  })})).filter(d=>d.stores.length>0);

  const af=fState!=="all"||fCond!=="all"||search;
  const total=homeDists.reduce((a,d)=>a+d.stores.length,0);
  const clear=()=>{setFState("all");setFCond("all");setSearch("");};
  const curD=nav.district?DISTRICTS.find(d=>d.key===nav.district):null;
  const curS=nav.store?allStores.find(s=>s.num===nav.store):null;
  const [regionTab, setRegionTab] = useState(0);
  const REGION_SUMMARY=(function(){
    var allSt=DISTRICTS.flatMap(function(d){return d.stores;});
    var liveH=allSt.filter(function(s){return FC_LIVE.has(s.num);}).map(function(s){return fhigh(s.num);}).filter(Boolean);
    if(!liveH.length)return null;
    var allFC=allSt.map(function(s){return FC[s.num]&&FC[s.num].forecast;}).filter(Boolean);
    var forecast=[0,1,2,3,4,5,6].map(function(di){var hs=allFC.map(function(f){return f[di]&&f[di].high;}).filter(Boolean);var ps=allFC.map(function(f){return f[di]&&f[di].precip;}).filter(function(x){return x!=null;});var cs=allFC.map(function(f){return f[di]&&f[di].cond;}).filter(Boolean);var ds=allFC.map(function(f){return f[di]&&f[di].day;}).filter(Boolean);return hs.length?{high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),precip:ps.length?Math.round(ps.reduce(function(a,b){return a+b;},0)/ps.length):0,cond:cs[0]||"Partly Cloudy",day:ds[0]||""}:null;}).filter(Boolean);
    var lwHighs=allSt.flatMap(function(s){return(LW[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    var lyHighs=allSt.flatMap(function(s){return(LY[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    var nwHighs=allSt.flatMap(function(s){return(NW[s.num]||[]).map(function(x){return x.high;});}).filter(Boolean);
    // Extras for richer insights
    var rainStores=allSt.filter(function(s){return FC[s.num]&&condPrecip(FC[s.num].cond);}).length;
    var tmrRainStores=allSt.filter(function(s){var f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[1];return f&&(condPrecip(f.cond)||f.precip>=40);}).length;
    // Hardest-hit district today
    var distRainCounts=DISTRICTS.map(function(d){return{name:d.dm.split(" ")[1],count:d.stores.filter(function(s){return FC[s.num]&&condPrecip(FC[s.num].cond);}).length};}).filter(function(d){return d.count>0;}).sort(function(a,b){return b.count-a.count;});
    var hardestDistrict=distRainCounts.length?distRainCounts[0].name:null;
    // IL vs MO split
    var ilH=ilDistricts.flatMap(function(d){return d.stores.map(function(s){return fhigh(s.num);});}).filter(Boolean);
    var moH=moDistricts.flatMap(function(d){return d.stores.map(function(s){return fhigh(s.num);});}).filter(Boolean);
    var ilAvgE=ilH.length?Math.round(ilH.reduce(function(a,b){return a+b;},0)/ilH.length):null;
    var moAvgE=moH.length?Math.round(moH.reduce(function(a,b){return a+b;},0)/moH.length):null;
    // Next week rain days
    var nwRainDays=nwHighs.length?[0,1,2,3,4,5,6].filter(function(di){return allSt.some(function(s){var f=NW[s.num]&&NW[s.num][di];return f&&(condPrecip(f.cond)||f.precip>=60);});}).length:null;
    var extras={rainStores:rainStores,tmrRainStores:tmrRainStores,hardestDistrict:hardestDistrict,ilAvg:ilAvgE,moAvg:moAvgE,nwRainDays:nwRainDays};
    return buildSummary({highs:liveH,forecast:forecast,lwHighs:lwHighs,lyHighs:lyHighs,nwHighs:nwHighs,storeCount:102,label:"Central Region",extras:extras});
  })();

  return (
    <div style={{minHeight:"100vh",background:"#EFEFEF",fontFamily:"-apple-system,BlinkMacSystemFont,'SF Pro Display','Helvetica Neue',sans-serif",color:C.black,WebkitFontSmoothing:"antialiased",paddingBottom:"env(safe-area-inset-bottom,24px)"}}>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}@keyframes spin{to{transform:rotate(360deg)}}*{box-sizing:border-box;-webkit-tap-highlight-color:transparent}button,select,input{font-family:inherit;-webkit-appearance:none;appearance:none}select{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23aaa'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;padding-right:28px!important}input:focus,select:focus{outline:2px solid #F96302;outline-offset:-1px}::-webkit-scrollbar{display:none}button:active{opacity:0.8}`}</style>


      <div style={{background:C.black,position:"sticky",top:0,zIndex:100,paddingTop:"env(safe-area-inset-top,0px)",boxShadow:"0 2px 16px rgba(0,0,0,0.35)"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",maxWidth:900,margin:"0 auto",gap:8}}>

          {/* LEFT — back button or HD logo + name */}
          <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>
            {nav.view!=="home"
              ?<button onClick={()=>{if(nav.view==="store")setNav({view:"district",district:nav.district});else setNav({view:"home"});}} style={{background:"rgba(255,255,255,0.12)",border:"none",borderRadius:20,padding:"6px 13px",fontSize:"0.72rem",fontWeight:700,color:C.white,cursor:"pointer",minHeight:34,flexShrink:0}}>{"← "+(nav.view==="store"&&curD?curD.dm.split(" ")[1]:"Home")}</button>
              :<div style={{display:"flex",alignItems:"center",gap:10}}>
                {/* HD logo box — incognito email trigger */}
                <button onClick={()=>setShowEmail(true)} style={{background:C.orange,borderRadius:9,width:38,height:38,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,border:"none",cursor:"pointer",padding:0,boxShadow:"0 2px 8px rgba(249,99,2,0.5)"}}>
                  <span style={{fontSize:"0.78rem",fontWeight:900,color:C.white,letterSpacing:"-0.03em",fontFamily:"Arial Black, sans-serif",lineHeight:1}}>HD</span>
                </button>
                <div style={{minWidth:0}}>
                  <div style={{fontSize:"0.92rem",fontWeight:800,color:C.white,lineHeight:1.1,letterSpacing:"-0.01em"}}>Central Region</div>
                  <div style={{fontSize:"0.55rem",color:"rgba(255,255,255,0.4)",letterSpacing:"0.07em",fontWeight:600}}>WEATHER DIGEST</div>
                </div>
              </div>
            }
          </div>

          {/* CENTER — district/store name when drilling in */}
          {nav.view!=="home"&&curD&&(
            <div style={{flex:1,textAlign:"center",minWidth:0}}>
              <div style={{fontSize:"0.82rem",fontWeight:700,color:C.white,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{nav.view==="store"&&curS?curS.name:curD.dm}</div>
              <div style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.45)"}}>{nav.view==="store"&&curS?"#"+curS.num+" · "+curD.dm:"D"+curD.num+" · "+curD.stores.length+" stores"}</div>
            </div>
          )}

          {/* RIGHT — IL/MO temps + radar button + last updated */}
          {nav.view==="home"&&(
            <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
              {/* IL and MO avg highs */}
              <div style={{background:"rgba(255,255,255,0.08)",borderRadius:20,padding:"5px 11px",display:"flex",alignItems:"center",gap:8}}>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:"0.95rem",lineHeight:1}}>{condIcon((()=>{var s=ilDistricts.flatMap(d=>d.stores).find(s=>FC_LIVE.has(s.num));return s&&FC[s.num]?FC[s.num].cond:"";})())}</span>
                  <div>
                    <div style={{fontSize:"0.72rem",fontWeight:800,color:C.white,lineHeight:1}}>{"IL "+ilAvgHigh+"°"}</div>
                    <div style={{fontSize:"0.44rem",color:"rgba(255,255,255,0.4)",letterSpacing:"0.05em"}}>AVG HIGH</div>
                  </div>
                </div>
                <div style={{width:1,height:20,background:"rgba(255,255,255,0.15)"}}/>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:"0.95rem",lineHeight:1}}>{condIcon((()=>{var s=moDistricts.flatMap(d=>d.stores).find(s=>FC_LIVE.has(s.num));return s&&FC[s.num]?FC[s.num].cond:"";})())}</span>
                  <div>
                    <div style={{fontSize:"0.72rem",fontWeight:800,color:C.white,lineHeight:1}}>{"MO "+moAvgHigh+"°"}</div>
                    <div style={{fontSize:"0.44rem",color:"rgba(255,255,255,0.4)",letterSpacing:"0.05em"}}>AVG HIGH</div>
                  </div>
                </div>
              </div>
              {/* Last updated */}
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:"0.62rem",fontWeight:700,color:"rgba(255,255,255,0.85)",whiteSpace:"nowrap"}}>{today}</div>
                <div style={{fontSize:"0.48rem",color:"rgba(255,255,255,0.35)",letterSpacing:"0.04em",whiteSpace:"nowrap",display:"flex",alignItems:"center",justifyContent:"flex-end",gap:4}}>
                  {_ldg
                    ? <><div style={{width:8,height:8,borderRadius:"50%",border:"1.5px solid rgba(249,99,2,0.3)",borderTopColor:"#F96302",animation:"spin 0.7s linear infinite",flexShrink:0}}/><span style={{color:"rgba(255,255,255,0.45)"}}>{"LOADING "+Math.min(_ldn,102)+"/102"}</span></>
                    : <><div style={{width:6,height:6,borderRadius:"50%",background:"#4caf50",flexShrink:0}}/><span>{"LIVE · "+new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}</span></>
                  }
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
      <div style={{maxWidth:900,margin:"0 auto",padding:"14px 12px 0",animation:"fadeUp 0.3s ease"}}>
      {nav.view==="district"&&curD&&<DistrictView district={curD} onBack={()=>setNav({view:"home"})} onStore={s=>setNav({view:"store",district:curD.key,store:s.num})}/>}
      {nav.view==="store"&&(
        curS&&curD
          ? <StoreDetail store={curS} district={curD} onBack={()=>setNav({view:"district",district:nav.district})}/>
          : <div style={{animation:"fadeUp 0.25s ease",padding:"20px 0"}}>
              <button onClick={()=>setNav({view:"home"})} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",color:C.orange,fontSize:"0.82rem",fontWeight:700,marginBottom:14,padding:0,fontFamily:"inherit"}}>← Home</button>
              <div style={{background:C.white,borderRadius:14,padding:"32px 18px",border:"1.5px solid "+C.border,textAlign:"center"}}>
                <div style={{width:28,height:28,borderRadius:"50%",border:"3px solid rgba(249,99,2,0.2)",borderTopColor:C.orange,animation:"spin 0.7s linear infinite",margin:"0 auto 12px"}}/>
                <div style={{fontSize:"0.82rem",color:C.g5,fontWeight:600}}>Loading store data...</div>
              </div>
            </div>
      )}
      {showEmail&&<EmailDigest onClose={()=>setShowEmail(false)}/>}

        {nav.view==="home"&&(
          <div>
            {/* Stats — two rows: IL/IN row + MO row */}
            {[
              {label:"Illinois / Indiana", pills:[
                {v:(pillVals.ilAvg||"—")+"°F "+(pillVals.ilVsLW!=null?(pillVals.ilVsLW>0?"↑":"↓"):""),l:"Avg High↑↓",c:(pillVals.ilAvg||0)>=avg?C.green:C.red,fn:()=>document.getElementById("heatmap")&&document.getElementById("heatmap").scrollIntoView({behavior:"smooth"})},
                {v:ilAlerts>0?"⚠ "+ilAlerts:"✓ 0", l:"Alerts",  c:ilAlerts>0?C.red:C.green,  fn:()=>ilAlerts>0?setShowAlerts("il"):null},
                {v:pillVals.ilVsLY!=null?(pillVals.ilVsLY>0?"+"+pillVals.ilVsLY+"°":pillVals.ilVsLY+"°"):"—", l:vsLYLabel,  c:(pillVals.ilVsLY||0)>0?C.od:(pillVals.ilVsLY||0)<0?C.blue:C.g5, fn:()=>setHistoryMode("ly")},
                {v:pillVals.ilVsLW!=null?(pillVals.ilVsLW>0?"+"+pillVals.ilVsLW+"°":pillVals.ilVsLW+"°"):"—",l:vsLabel, c:(pillVals.ilVsLW||0)<0?C.blue:C.od, fn:()=>setHistoryMode("lw")},
                {v:pillVals.ilBestLabel, l:"Best Day", c:C.green, fn:()=>setTooltipPill(tooltipPill==="bestday"?null:"bestday")},
                {v:pillVals.ilWS+"/10",l:"Wknd",c:wkndColor2(pillVals.ilWS),fn:function(){setTooltipPill("wknd");}},
                {v:pillVals.ilGP+"%",l:pillVals.ilGP>=60?"✅ Good Week":pillVals.ilGP>=40?"⚠ Mixed Week":"📋 Marathon",c:pillVals.ilGP>=60?C.green:pillVals.ilGP>=40?C.od:C.red,fn:()=>setTooltipPill("goodweek")},
              ]},
              {label:"Missouri", pills:[
                {v:(pillVals.moAvg||"—")+"°F "+(pillVals.moVsLW!=null?(pillVals.moVsLW>0?"↑":"↓"):""),l:"Avg High↑↓",c:(pillVals.moAvg||0)>=avg?C.green:C.red,fn:()=>document.getElementById("heatmap")&&document.getElementById("heatmap").scrollIntoView({behavior:"smooth"})},
                {v:moAlerts>0?"⚠ "+moAlerts:"✓ 0", l:"Alerts",  c:moAlerts>0?C.red:C.green,  fn:()=>moAlerts>0?setShowAlerts("mo"):null},
                {v:pillVals.moVsLY!=null?(pillVals.moVsLY>0?"+"+pillVals.moVsLY+"°":pillVals.moVsLY+"°"):"—", l:vsLYLabel,  c:(pillVals.moVsLY||0)>0?C.od:(pillVals.moVsLY||0)<0?C.blue:C.g5, fn:()=>setHistoryMode("ly")},
                {v:pillVals.moVsLW!=null?(pillVals.moVsLW>0?"+"+pillVals.moVsLW+"°":pillVals.moVsLW+"°"):"—",l:vsLabel, c:(pillVals.moVsLW||0)<0?C.blue:C.od, fn:()=>setHistoryMode("lw")},
                {v:pillVals.moBestLabel, l:"Best Day", c:C.green, fn:()=>setTooltipPill(tooltipPill==="bestday"?null:"bestday")},
                {v:pillVals.moWS+"/10",l:"Wknd",c:wkndColor2(pillVals.moWS),fn:function(){setTooltipPill("wknd");}},
                {v:pillVals.moGP+"%",l:pillVals.moGP>=60?"✅ Good Week":pillVals.moGP>=40?"⚠ Mixed Week":"📋 Marathon",c:pillVals.moGP>=60?C.green:pillVals.moGP>=40?C.od:C.red,fn:()=>setTooltipPill("goodweek")},
              ]},
            ].map((row,ri)=>(
              <div key={ri} style={{marginBottom:10}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:5,paddingLeft:2}}>
                  <div style={{fontSize:"0.58rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em"}}>{row.label.toUpperCase()}</div>
                  {ri===0&&<div style={{display:"flex",gap:4,background:C.g1,borderRadius:8,padding:"2px 3px",border:"1px solid "+C.border}}>
                    {weekLabels.map((wl,wi)=>(
                      <button key={wi} onClick={()=>setWeekIdx(wi)} style={{padding:"3px 8px",borderRadius:6,fontSize:"0.55rem",fontWeight:700,border:"none",cursor:"pointer",fontFamily:"inherit",background:weekIdx===wi?C.orange:"transparent",color:weekIdx===wi?C.white:C.g5,whiteSpace:"nowrap",letterSpacing:"0.02em"}}>{wl}</button>
                    ))}
                  </div>}
                </div>
                <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:2}}>
                  {row.pills.map((s,i)=>(
                    <button key={i} onClick={s.fn} style={{flex:"0 0 auto",minWidth:72,background:C.white,borderRadius:10,padding:"8px 10px",border:"1px solid "+C.border,textAlign:"center",boxShadow:"0 1px 3px rgba(0,0,0,0.06)",cursor:"pointer",fontFamily:"inherit",WebkitTapHighlightColor:"transparent"}}>
                      <div style={{fontSize:"1rem",fontWeight:800,color:s.c,lineHeight:1}}>{s.v}</div>
                      <div style={{fontSize:"0.55rem",color:C.g5,fontWeight:600,letterSpacing:"0.04em",marginTop:3}}>{s.l.toUpperCase()}</div>
                    </button>
                  ))}
                </div>
                {/* 7-day strip — synced to weekIdx */}
                {(()=>{
                  var districts = ri===0 ? ilDistricts : moDistricts;
                  var strip = getStrip({stores:districts.flatMap(function(d){return d.stores;})}, weekIdx);
                  // getStrip expects a district object; build a virtual one spanning all stores
                  // Re-compute manually using same logic as getStrip but across all districts
                  var allStoresR = districts.flatMap(function(d){return d.stores;});
                  strip = [0,1,2,3,4,5,6].map(function(di){
                    var hs=[],cs=[],ps=[],ds=[];
                    allStoresR.forEach(function(s){
                      var f=null;
                      if(weekIdx===0){f=LW[s.num]&&LW[s.num][di];}
                      else if(weekIdx===2){f=NW[s.num]&&NW[s.num][di];}
                      else{f=FC[s.num]&&FC[s.num].forecast&&FC[s.num].forecast[di];}
                      if(f&&f.high){hs.push(f.high);cs.push(f.cond||"Partly Cloudy");ps.push(f.precip||0);ds.push(f.day||"");}
                    });
                    if(!hs.length)return null;
                    return{high:Math.round(hs.reduce((a,b)=>a+b,0)/hs.length),cond:cs[0]||"Partly Cloudy",precip:Math.round(ps.reduce((a,b)=>a+b,0)/ps.length),day:ds[0]||""};
                  }).filter(Boolean);
                  if(!strip.length)return null;
                  // Build date-based day labels matching heatmap headers
                  var today2=new Date();today2.setHours(0,0,0,0);
                  var offsets2=[-7,0,7];
                  var DN2=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
                  return(
                    <div style={{display:"flex",gap:4,marginTop:6,overflowX:"auto",paddingBottom:2}}>
                      {strip.map(function(day,i){
                        var d2=new Date(today2);d2.setDate(today2.getDate()+offsets2[weekIdx]+i);
                        var dayLabel=weekIdx===1&&i===0?"TODAY":DN2[d2.getDay()].toUpperCase().slice(0,3);
                        var isToday=weekIdx===1&&i===0;
                        var isPrecip=condPrecip(day.cond)||(weekIdx!==0&&day.precip>=40);
                        var isGood=condGood(day.cond)&&day.high>=avg;
                        var bg=isPrecip?"rgba(198,40,40,0.08)":isGood?"rgba(46,125,50,0.08)":"rgba(0,0,0,0.03)";
                        var tempColor=isPrecip?C.red:isGood?C.green:day.high<avg-5?C.blue:C.g5;
                        return(
                          <div key={i} style={{flex:"1 1 0",minWidth:38,background:isToday?"rgba(249,99,2,0.07)":bg,borderRadius:8,padding:"6px 3px 5px",textAlign:"center",border:isToday?"1.5px solid rgba(249,99,2,0.3)":"1px solid "+C.border}}>
                            <div style={{fontSize:"0.52rem",fontWeight:700,color:isToday?C.orange:C.g4,letterSpacing:"0.03em",marginBottom:2}}>{dayLabel}</div>
                            <div style={{fontSize:"1rem",lineHeight:1,marginBottom:2}}>{condIcon(day.cond)}</div>
                            <div style={{fontSize:"0.78rem",fontWeight:800,color:tempColor,lineHeight:1}}>{day.high+"°"}</div>
                            {day.precip>=20&&weekIdx!==0&&<div style={{fontSize:"0.45rem",color:C.blue,fontWeight:600,marginTop:1}}>{day.precip+"%"}</div>}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            ))}
            {historyMode&&(
        <div onClick={function(){setHistoryMode(null);}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={function(e){e.stopPropagation();}} style={{background:C.white,borderRadius:"16px 16px 0 0",width:"100%",maxWidth:600,maxHeight:"80vh",overflowY:"auto",padding:"20px 16px 32px"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
              <div>
                <div style={{fontWeight:800,fontSize:"1rem",color:C.black}}>{historyMode==="lw"?"Last Week Actuals":"Last Year Actuals"}</div>
                <div style={{fontSize:"0.68rem",color:C.g5,marginTop:2}}>{(function(){var e=new Date();e.setDate(e.getDate()-8);var s=new Date(e);s.setDate(e.getDate()-6);var mn=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];var yr=historyMode==="ly"?e.getFullYear()-1:e.getFullYear();return mn[s.getMonth()]+" "+s.getDate()+"-"+mn[e.getMonth()]+" "+e.getDate()+", "+yr;}())}</div>
              </div>
              <button onClick={function(){setHistoryMode(null);}} style={{background:C.g1,border:"1px solid "+C.border,borderRadius:8,padding:"6px 12px",fontSize:"0.78rem",cursor:"pointer",fontFamily:"inherit"}}>{"Close"}</button>
            </div>
            <div style={{display:"flex",gap:4,marginBottom:14,background:C.g1,borderRadius:8,padding:3}}>
              {["Last Week","Last Year"].map(function(t,i){return(
                <button key={i} onClick={function(){setHistoryMode(i===0?"lw":"ly");}} style={{flex:1,padding:"6px",borderRadius:6,fontSize:"0.72rem",fontWeight:600,border:"none",cursor:"pointer",fontFamily:"inherit",background:historyMode===(i===0?"lw":"ly")?C.orange:"transparent",color:historyMode===(i===0?"lw":"ly")?C.white:C.g5}}>{t}</button>
              );})}
            </div>
            {DISTRICTS.map(function(d){
              // Average strip across all stores in district
              var srcMap = historyMode==="lw" ? LW : LY;
              var strips = d.stores.map(function(s){return srcMap[s.num];}).filter(Boolean);
              if(!strips.length)return null;
              var strip=[0,1,2,3,4,5,6].map(function(di){
                var hs=strips.map(function(st){return st[di]&&st[di].high;}).filter(Boolean);
                var cs=strips.map(function(st){return st[di]&&st[di].cond;}).filter(Boolean);
                var ds=strips.map(function(st){return st[di]&&st[di].day;}).filter(Boolean);
                return hs.length?{day:ds[0]||"",high:Math.round(hs.reduce(function(a,b){return a+b;},0)/hs.length),cond:cs[0]||"Partly Cloudy"}:null;
              }).filter(Boolean);
              if(!strip.length)return null;
              return(
                <div key={d.key} style={{marginBottom:14,paddingBottom:14,borderBottom:"1px solid "+C.border}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                    <div style={{width:34,height:34,borderRadius:7,background:C.orange,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.65rem",fontWeight:800,color:C.white,flexShrink:0}}>{"D"+d.num}</div>
                    <div><div style={{fontWeight:700,fontSize:"0.84rem",color:C.black}}>{d.dm}</div><div style={{fontSize:"0.6rem",color:C.g5}}>{d.region}</div></div>
                  </div>
                  <div style={{display:"flex",gap:3,overflowX:"auto"}}>
                    {strip.map(function(day,i){return(
                      <div key={i} style={{flex:"0 0 auto",width:44,borderRadius:7,padding:"6px 3px",textAlign:"center",background:C.g1,border:"1px solid "+C.border}}>
                        <div style={{fontSize:"0.52rem",fontWeight:700,color:C.g5}}>{day.day}</div>
                        <div style={{fontSize:"0.95rem"}}>{condIcon(day.cond)}</div>
                        <div style={{fontSize:"0.7rem",fontWeight:800,color:C.black}}>{day.high}°</div>
                        <div style={{fontSize:"0.56rem",color:C.g5}}>{day.low||""}°</div>
                      </div>
                    );})}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {tooltipPill&&(
              <div style={{background:C.black,color:C.white,borderRadius:10,padding:"12px 14px",marginBottom:12,fontSize:"0.75rem",lineHeight:1.5,position:"relative"}}>
                <button onClick={()=>setTooltipPill(null)} style={{position:"absolute",top:8,right:10,background:"none",border:"none",color:"rgba(255,255,255,0.5)",cursor:"pointer",fontFamily:"inherit",fontSize:"0.8rem"}}>{"✕"}</button>
                {tooltipPill==="bestday"&&<>
                  <div style={{fontWeight:800,marginBottom:4}}>{"📅 Best Day (This Wk · Next Wk)"}</div>
                  <div>{"The day with the highest composite weather score across all 10 districts — factoring in dry conditions, sunny skies, and temps at or above seasonal average ("+avg+"°F for "+["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][new Date().getMonth()]+")."}</div>
                </>}
                {tooltipPill==="goodweek"&&<>
                  <div style={{fontWeight:800,marginBottom:4}}>{(goodDistrictDays/70*100>=60?"✅ Good Week":goodDistrictDays/70*100>=40?"⚠ Mixed Week":"📋 Quote Marathon")+" — "+Math.round(goodDistrictDays/70*100)+"%"}</div>
                  <div>{"% of district-days this week with favorable conditions: no precipitation, under 40% precip chance, and high at or above seasonal avg ("+avg+"°F). "+goodDistrictDays+" of 70 possible district-days qualify (10 districts × 7 days)."}</div>
                </>}
              </div>
            )}

            <div id="alertbanner"/>
            {/* ── FEATURE 8: Active Storm Alert Banner ── */}
            {ALERTS.length > 0 && (
              <div style={{background:"#7B0000",borderRadius:12,padding:"12px 14px",
                marginBottom:12,border:"2px solid #FF4444"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <span style={{fontSize:"1.1rem"}}>🚨</span>
                  <span style={{fontWeight:800,fontSize:"0.88rem",color:C.white}}>
                    {"Active NWS Alerts ("+ALERTS.length+")"}
                  </span>
                  <span style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.6)",
                    background:"rgba(255,255,255,0.15)",padding:"1px 8px",borderRadius:99}}>
                    {new Date().toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
                  </span>
                </div>
                {ALERTS.map((a,i)=>(
                  <div key={i} style={{background:"rgba(255,255,255,0.1)",borderRadius:8,
                    padding:"8px 10px",marginBottom:i<ALERTS.length-1?6:0}}>
                    <div style={{display:"flex",justifyContent:"space-between",
                      alignItems:"flex-start",gap:8,marginBottom:3}}>
                      <span style={{fontWeight:700,fontSize:"0.78rem",color:"#FFD0D0"}}>
                        {"⚠ "+a.type}
                      </span>
                      <span style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.5)",
                        whiteSpace:"nowrap",flexShrink:0}}>
                        {"Until "+a.expires}
                      </span>
                    </div>
                    <div style={{fontSize:"0.68rem",color:"rgba(255,255,255,0.7)",marginBottom:2}}>
                      {"📍 "+a.area}
                    </div>
                    <div style={{fontSize:"0.66rem",color:"rgba(255,255,255,0.55)"}}>
                      {a.detail}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div id="heatmap"/>
            {/* Precip window countdown */}
            {precipCountdown&&(
              <div style={{background:precipCountdown.daysAway===0?C.rl:precipCountdown.daysAway<=2?"#FFF8E1":C.gl,borderRadius:10,padding:"10px 14px",marginBottom:10,border:"1px solid "+(precipCountdown.daysAway===0?C.red:precipCountdown.daysAway<=2?"#F9A825":C.green),display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:"1.1rem"}}>{precipCountdown.daysAway===0?"🌧️":precipCountdown.daysAway<=2?"⚠️":"🌦️"}</span>
                  <div>
                    <div style={{fontSize:"0.78rem",fontWeight:800,color:C.black}}>
                      {precipCountdown.daysAway===0?"Precip affecting region now":precipCountdown.daysAway===1?"Rain window tomorrow":"Next rain window: "+precipCountdown.dayName}
                    </div>
                    <div style={{fontSize:"0.6rem",color:C.g5,marginTop:1}}>
                      {precipCountdown.storeCount+" of 102 stores · avg "+precipCountdown.avgPrecip+"% chance"}
                    </div>
                  </div>
                </div>
                <div style={{fontSize:"0.7rem",fontWeight:800,color:precipCountdown.daysAway===0?C.red:precipCountdown.daysAway<=2?"#E65100":C.green,flexShrink:0}}>
                  {precipCountdown.daysAway===0?"TODAY":precipCountdown.daysAway===1?"TOMORROW":"in "+precipCountdown.daysAway+"d"}
                </div>
              </div>
            )}
            {/* District ranking + radar buttons */}
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              <button onClick={()=>setShowRanking(true)} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:8,background:C.black,border:"none",borderRadius:10,padding:"11px 14px",cursor:"pointer",fontFamily:"inherit"}}>
                <span style={{fontSize:"1rem"}}>🏆</span>
                <div style={{textAlign:"left"}}>
                  <div style={{fontSize:"0.75rem",fontWeight:800,color:C.white,lineHeight:1.2}}>District Ranking</div>
                  <div style={{fontSize:"0.55rem",color:"rgba(255,255,255,0.45)",marginTop:1}}>Best weather this week</div>
                </div>
              </button>
              <button onClick={()=>setShowRadar(true)} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:8,background:"#1a2744",border:"none",borderRadius:10,padding:"11px 14px",cursor:"pointer",fontFamily:"inherit"}}>
                <span style={{fontSize:"1rem"}}>🛰️</span>
                <div style={{textAlign:"left"}}>
                  <div style={{fontSize:"0.75rem",fontWeight:800,color:C.white,lineHeight:1.2}}>Live Radar</div>
                  <div style={{fontSize:"0.55rem",color:"rgba(255,255,255,0.45)",marginTop:1}}>Past 2hr · Today · Tomorrow</div>
                </div>
              </button>
            </div>
            {/* ── FEATURE 5: Week-at-a-Glance Heat Map ── */}
            <WeekHeatMap weekIdx={weekIdx} setWeekIdx={setWeekIdx}/>

            {/* Regional Summary with tabs */}
            {(()=>{
              var rsKey=["today","tomorrow","week","nextWeek"][regionTab];
              var rsText=REGION_SUMMARY&&REGION_SUMMARY[rsKey];
              if(!REGION_SUMMARY||!rsText)return null;
              return(
              <div style={{background:C.black,borderRadius:12,padding:"14px 16px",marginBottom:14,border:"2px solid "+C.orange}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:10}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:"1rem"}}>{"🤖"}</span>
                    <span style={{fontWeight:800,fontSize:"0.88rem",color:C.white}}>Regional Summary</span>
                    <span style={{fontSize:"0.6rem",color:"rgba(255,255,255,0.4)",background:"rgba(255,255,255,0.08)",padding:"1px 8px",borderRadius:99}}>{new Date().toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</span>
                  </div>
                  <div style={{display:"flex",gap:3,background:"rgba(255,255,255,0.1)",borderRadius:8,padding:3}}>
                    {["Today","Tomorrow","This Week","Next Week"].map((t,i)=>(
                      <button key={i} onClick={()=>setRegionTab(i)} style={{
                        padding:"5px 10px",borderRadius:6,fontSize:"0.68rem",fontWeight:600,
                        border:"none",cursor:"pointer",fontFamily:"inherit",minHeight:30,
                        background:regionTab===i?C.orange:"transparent",
                        color:regionTab===i?C.white:"rgba(255,255,255,0.4)"}}>
                        {t}
                      </button>
                    ))}
                  </div>
                </div>
                <p style={{margin:0,color:C.white,fontSize:"0.84rem",lineHeight:1.65}}>{rsText}</p>
              </div>
              );
            })()}

            {/* Weekly Briefing button */}
            {(()=>{
              var DN3=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
              var mn3=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
              var now=new Date();
              var briefing=[
                "☀️ HAMAD CENTRAL WEATHER DIGEST — "+DN3[now.getDay()]+", "+mn3[now.getMonth()]+" "+now.getDate()+", "+now.getFullYear(),
                "━".repeat(48),
                "",
                "REGION SNAPSHOT",
                "  IL/IN Avg High: "+(ilAvgHigh||"—")+"°F  |  MO Avg High: "+(moAvgHigh||"—")+"°F",
                "  Seasonal Avg: "+avg+"°F",
                REGION_SUMMARY&&REGION_SUMMARY.today?"  "+REGION_SUMMARY.today:"",
                precipCountdown?"  ⚠ Next rain window: "+precipCountdown.dayName+" ("+precipCountdown.storeCount+" stores, avg "+precipCountdown.avgPrecip+"%)":"  ✓ No significant precip in next 7 days",
                "",
                "DISTRICT RANKINGS (weather score this week)",
                districtRanking.slice(0,10).map(function(d,i){return"  "+(i+1)+". D"+d.num+" "+d.dm.split(" ").slice(1).join(" ")+" ("+d.region+") — "+d.avgH+"°F avg"+(d.rainToday>0?", "+d.rainToday+" stores w/ rain today":"");}).join("\n"),
                "",
                "THIS WEEK OUTLOOK",
                REGION_SUMMARY&&REGION_SUMMARY.week?"  "+REGION_SUMMARY.week:"",
                "",
                "NEXT WEEK OUTLOOK",
                REGION_SUMMARY&&REGION_SUMMARY.nextWeek?"  "+REGION_SUMMARY.nextWeek:"",
                "",
                "━".repeat(48),
                "Data: "+DATA_SOURCE+" · "+DATA_DATE,
              ].filter(function(l){return l!=null;}).join("\n");
              return(
                <button onClick={function(){
                  try{var el=document.createElement("textarea");el.value=briefing;el.style.cssText="position:fixed;top:-9999px;left:-9999px;";document.body.appendChild(el);el.select();document.execCommand("copy");document.body.removeChild(el);setShowEmailModal(true);setTimeout(function(){setShowEmailModal(false);},2500);}catch(e){}
                }} style={{width:"100%",display:"flex",alignItems:"center",gap:10,background:C.white,border:"1px solid "+C.border,borderRadius:12,padding:"12px 14px",cursor:"pointer",marginBottom:12,fontFamily:"inherit",boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
                  <span style={{fontSize:"1rem"}}>📋</span>
                  <div style={{textAlign:"left",flex:1}}>
                    <div style={{fontSize:"0.8rem",fontWeight:700,color:C.black}}>{showEmailModal?"✅ Copied to clipboard!":"Copy Morning Weather Briefing"}</div>
                    <div style={{fontSize:"0.58rem",color:C.g5,marginTop:1}}>Full region digest · paste into Teams or email</div>
                  </div>
                  <span style={{color:C.g3}}>›</span>
                </button>
              );
            })()}
            <div style={{background:C.white,borderRadius:12,marginBottom:12,border:"1.5px solid "+C.border,boxShadow:"0 1px 4px rgba(0,0,0,0.08)",overflow:"hidden"}}>
              <button onClick={()=>setShowF(!showF)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 14px",background:"none",border:"none",minHeight:48,cursor:"pointer"}}>
                <div style={{display:"flex",alignItems:"center",gap:7}}><span>🔍</span><span style={{fontSize:"0.82rem",fontWeight:700,color:C.black}}>Filter Stores</span>{af&&<span style={{background:C.orange,color:C.white,fontSize:"0.6rem",fontWeight:800,padding:"1px 8px",borderRadius:99}}>{total}</span>}</div>
                <span style={{color:C.g3,fontSize:"0.82rem"}}>{showF?"▲":"▼"}</span>
              </button>
              {showF&&(
                <div style={{padding:"4px 14px 14px",borderTop:"1px solid "+C.border,background:"#FAFAFA"}}>
                  <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search store, DM, city, or #…" style={{width:"100%",padding:"10px 12px",borderRadius:9,marginTop:10,marginBottom:10,border:"1.5px solid "+(search?C.orange:C.border),fontSize:"0.82rem",color:C.black,background:C.white}}/>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                    {[{l:"STATE",v:fState,set:setFState,opts:[{v:"all",l:"All States"},{v:"IL",l:"Illinois"},{v:"MO",l:"Missouri"},{v:"IN",l:"Indiana"}]},{l:"CONDITIONS",v:fCond,set:setFCond,opts:[{v:"all",l:"All"},{v:"good",l:"✓ Good"},{v:"alerts",l:"⚠ Alerts"}]}].map(x=>(
                      <div key={x.l}>
                        <div style={{fontSize:"0.57rem",color:C.g5,fontWeight:700,letterSpacing:"0.06em",marginBottom:5}}>{x.l}</div>
                        <select value={x.v} onChange={e=>x.set(e.target.value)} style={{width:"100%",padding:"9px 28px 9px 10px",borderRadius:8,border:"1.5px solid "+(x.v!=="all"?C.orange:C.border),fontSize:"0.78rem",color:C.black,background:C.white}}>
                          {x.opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      </div>
                    ))}
                  </div>
                  {af&&<button onClick={clear} style={{marginTop:10,width:"100%",padding:"10px",borderRadius:8,background:C.ol,border:"1.5px solid "+C.orange,color:C.od,fontSize:"0.8rem",fontWeight:700,cursor:"pointer",minHeight:40}}>Clear Filters</button>}
                </div>
              )}
            </div>

            <div style={{fontSize:"0.63rem",fontWeight:700,color:C.g3,letterSpacing:"0.07em",marginBottom:8,paddingLeft:2}}>
              {(function(){var tot=homeDists.reduce(function(a,d){return a+d.stores.length;},0);var d=new Date();d.setDate(d.getDate()-7);var mn=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];return tot+" OF 102 STORES · VS "+mn[d.getMonth()].toUpperCase()+" "+d.getDate()+", "+(d.getFullYear()-1);}())}
            </div>

            {homeDists.length===0
              ?<div style={{textAlign:"center",padding:"50px 20px",background:C.white,borderRadius:12,border:"1px solid "+C.border}}><div style={{fontSize:"2rem",marginBottom:8}}>🔍</div><div style={{fontSize:"0.88rem",fontWeight:600,color:C.g5,marginBottom:14}}>No stores match</div><button onClick={clear} style={{padding:"10px 24px",borderRadius:9,background:C.orange,color:C.white,border:"none",fontWeight:700,fontSize:"0.82rem",cursor:"pointer",minHeight:44}}>Clear Filters</button></div>
              :homeDists.map(d=><DistRow key={d.key} district={d} onClick={()=>setNav({view:"district",district:d.key})} onTip={function(t){setTooltipPill(t);}}/>)}
          </div>
        )}

          {showRadar&&(
        <div style={{position:"fixed",inset:0,zIndex:400,background:C.black,display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",paddingTop:"calc(12px + env(safe-area-inset-top,0px))",flexShrink:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:"1.1rem"}}>🛰️</span>
              <div>
                <div style={{fontWeight:800,fontSize:"0.9rem",color:C.white}}>Live Radar</div>
                <div style={{fontSize:"0.58rem",color:"rgba(255,255,255,0.45)"}}>IL · IN · MO · RainViewer</div>
              </div>
            </div>
            <button onClick={()=>setShowRadar(false)} style={{background:"rgba(255,255,255,0.12)",border:"none",borderRadius:20,padding:"8px 16px",color:C.white,fontSize:"0.78rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",minHeight:36}}>✕ Close</button>
          </div>
          <div style={{flex:1,position:"relative",overflow:"hidden"}}>
            <iframe title="Radar" style={{width:"100%",height:"100%",border:"none"}} srcDoc={
              `<!DOCTYPE html><html><head>
<meta name="viewport" content="width=device-width,initial-scale=1">
<link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"/>
<script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
<style>
*{margin:0;padding:0;box-sizing:border-box;}
body{background:#111;font-family:-apple-system,sans-serif;}
#map{width:100%;height:100vh;}
#ctrl{position:fixed;bottom:0;left:0;right:0;z-index:1000;background:rgba(0,0,0,0.92);padding:10px 12px;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));}
#tabs{display:grid;grid-template-columns:1fr 1fr 1fr;gap:5px;margin-bottom:8px;}
#tabs button{padding:8px 4px;border:none;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit;line-height:1.2;}
.on{background:#F96302;color:#fff;}.off{background:rgba(255,255,255,0.1);color:rgba(255,255,255,0.55);}
#tl{display:flex;align-items:center;gap:8px;}
#sl{flex:1;accent-color:#F96302;}
#lbl{font-size:11px;color:rgba(255,255,255,0.55);white-space:nowrap;min-width:60px;text-align:right;}
#pb{background:rgba(255,255,255,0.15);border:none;border-radius:7px;padding:6px 12px;color:#fff;font-size:15px;cursor:pointer;}
#leg{display:none;gap:12px;margin-top:7px;font-size:10px;color:rgba(255,255,255,0.5);}
.ld{display:inline-block;width:9px;height:9px;border-radius:50%;margin-right:3px;vertical-align:middle;}
</style></head><body>
<div id="map"></div>
<div id="ctrl">
  <div id="tabs">
    <button id="t0" class="on"  onclick="setM(0)">◀ Past 2hr</button>
    <button id="t1" class="off" onclick="setM(1)">⚡ Live</button>
    <button id="t2" class="off" onclick="setM(2)">Today</button>
    <button id="t3" class="off" onclick="setM(3)">Tomorrow</button>
    <button id="t4" class="off" onclick="setM(4)" id="t4"></button>
    <button id="t5" class="off" onclick="setM(5)" id="t5"></button>
  </div>
  <div id="tl"><button id="pb" onclick="tog()">▶</button><input id="sl" type="range" min="0" max="11" value="11" oninput="seek(this.value)"/><span id="lbl">--:--</span></div>
  <div id="leg"><span><span class="ld" style="background:#C62828"></span>≥60%</span><span><span class="ld" style="background:#F9A825"></span>30-59%</span><span><span class="ld" style="background:#2E7D32"></span>&lt;30%</span></div>
</div>
<script>
var SAT_IDX=${(()=>{var t=new Date();for(var i=1;i<=7;i++){var d=new Date(t);d.setDate(t.getDate()+i);if(d.getDay()===6)return i;}return 6;})()};
var SUN_IDX=${(()=>{var t=new Date();for(var i=1;i<=7;i++){var d=new Date(t);d.setDate(t.getDate()+i);if(d.getDay()===0)return i;}return 7;})()};
var SAT_LABEL=${JSON.stringify((()=>{var t=new Date();for(var i=1;i<=7;i++){var d=new Date(t);d.setDate(t.getDate()+i);if(d.getDay()===6)return"Sat "+(d.getMonth()+1)+"/"+d.getDate();}return"Sat";})())};
var SUN_LABEL=${JSON.stringify((()=>{var t=new Date();for(var i=1;i<=7;i++){var d=new Date(t);d.setDate(t.getDate()+i);if(d.getDay()===0)return"Sun "+(d.getMonth()+1)+"/"+d.getDate();}return"Sun";})())};
var STORES=`+JSON.stringify(Object.entries(STORE_COORDS).map(([n,[la,lo]])=>{
  const fc=FC[n]&&FC[n].forecast||[];
  // Compute sat/sun indices dynamically
  const today2=new Date(); today2.setHours(0,0,0,0);
  let satIdx=6,sunIdx=7;
  for(let i=1;i<=7;i++){const d=new Date(today2);d.setDate(today2.getDate()+i);if(d.getDay()===6){satIdx=i;break;}}
  for(let i=1;i<=7;i++){const d=new Date(today2);d.setDate(today2.getDate()+i);if(d.getDay()===0){sunIdx=i;break;}}
  return{
    n,la,lo,
    tp:(fc[0]&&fc[0].precip)||0, tc:(fc[0]&&fc[0].cond)||'',
    pp:(fc[1]&&fc[1].precip)||0, pc:(fc[1]&&fc[1].cond)||'',
    sp:(fc[satIdx]&&fc[satIdx].precip)||0, sc:(fc[satIdx]&&fc[satIdx].cond)||'',
    sup:(fc[sunIdx]&&fc[sunIdx].precip)||0, suc:(fc[sunIdx]&&fc[sunIdx].cond)||'',
  };
}))+`;
// Set Sat/Sun button labels
document.getElementById('t4').textContent=SAT_LABEL+' Precip';
document.getElementById('t5').textContent=SUN_LABEL+' Precip';
var map=L.map('map',{zoomControl:true,attributionControl:false}).setView([40.2,-89.5],6);
L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',{maxZoom:18}).addTo(map);
L.rectangle([[36.9,-91.5],[42.5,-87.0]],{color:'#F96302',weight:1.5,fill:false,dashArray:'4,4',opacity:0.4}).addTo(map);
var rl=null,fr=[],mode=0,idx=0,pl=false,pit=null,dl=null;
function setM(m){
  mode=m;
  [0,1,2,3,4,5].forEach(function(i){var el=document.getElementById('t'+i);if(el)el.className=i===m?'on':'off';});
  var showTl=m===0;
  document.getElementById('tl').style.display=showTl?'flex':'none';
  document.getElementById('leg').style.display=(m>=2)?'flex':'none';
  stopPl();
  if(rl){map.removeLayer(rl);rl=null;}
  if(dl){map.removeLayer(dl);dl=null;}
  if(m===0){if(fr.length)showFr(idx);}
  else if(m===1){showLive();}
  else if(m===2){showDots('tp','tc','Today');}
  else if(m===3){showDots('pp','pc','Tomorrow');}
  else if(m===4){showDots('sp','sc',SAT_LABEL);}
  else{showDots('sup','suc',SUN_LABEL);}
}
function showLive(){
  if(!fr.length)return;
  var f=fr[fr.length-1];
  rl=L.tileLayer('https://tilecache.rainviewer.com'+f.path+'/256/{z}/{x}/{y}/2/1_1.png',{opacity:0.8,maxZoom:18,tileSize:256,zIndex:10}).addTo(map);
  var d=new Date(f.time*1000),h=d.getHours(),mi=d.getMinutes();
  document.getElementById('lbl').textContent='Live '+(h<10?'0'+h:h)+':'+(mi<10?'0'+mi:mi);
}
function showDots(precipKey,condKey,label){
  if(dl){map.removeLayer(dl);dl=null;}
  var g=L.layerGroup().addTo(map);dl=g;
  STORES.forEach(function(s){
    var precip=s[precipKey]||0;
    var cond=s[condKey]||'';
    var col=precip>=60?'#C62828':precip>=30?'#F9A825':'#2E7D32';
    var r=precip>=60?9:precip>=30?7:5;
    L.circleMarker([s.la,s.lo],{radius:r,fillColor:col,color:'rgba(0,0,0,0.4)',weight:1,fillOpacity:0.9})
     .bindPopup('<b>#'+s.n+'</b><br>'+label+': '+precip+'%<br>'+cond).addTo(g);
  });
  document.getElementById('lbl').textContent=label;
}
function showFr(i){
  if(!fr[i])return;
  if(rl)map.removeLayer(rl);
  rl=L.tileLayer('https://tilecache.rainviewer.com'+fr[i].path+'/256/{z}/{x}/{y}/2/1_1.png',{opacity:0.75,maxZoom:18,tileSize:256,zIndex:10}).addTo(map);
  var d=new Date(fr[i].time*1000),h=d.getHours(),m=d.getMinutes();
  document.getElementById('lbl').textContent=(h<10?'0'+h:h)+':'+(m<10?'0'+m:m);
  document.getElementById('sl').value=i;
}
function seek(v){stopPl();idx=parseInt(v);showFr(idx);}
function tog(){pl?stopPl():startPl();}
function startPl(){pl=true;document.getElementById('pb').textContent='⏸';pit=setInterval(function(){idx=(idx+1)%fr.length;showFr(idx);},500);}
function stopPl(){pl=false;clearInterval(pit);document.getElementById('pb').textContent='▶';}
fetch('https://api.rainviewer.com/public/weather-maps.json')
  .then(function(r){return r.json();})
  .then(function(d){fr=d.radar.past.slice(-12);var sl=document.getElementById('sl');sl.max=fr.length-1;sl.value=fr.length-1;idx=fr.length-1;showFr(idx);})
  .catch(function(){document.getElementById('lbl').textContent='Offline';});
</script></body></html>`}
            />
          </div>
        </div>
      )}

          {showRanking&&(
        <div onClick={()=>setShowRanking(false)} style={{position:"fixed",inset:0,zIndex:300,background:"rgba(0,0,0,0.6)"}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"fixed",bottom:0,left:0,right:0,maxWidth:600,margin:"0 auto",background:C.white,borderRadius:"16px 16px 0 0",padding:"20px 16px 32px",maxHeight:"80vh",overflowY:"auto",boxShadow:"0 -4px 24px rgba(0,0,0,0.3)"}}>
            <div style={{width:36,height:4,background:C.border,borderRadius:2,margin:"0 auto 16px"}}/>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:4}}>
              <div style={{fontWeight:800,fontSize:"0.95rem",color:C.black}}>🏆 District Weather Ranking</div>
              <button onClick={()=>setShowRanking(false)} style={{background:C.g1,border:"1px solid "+C.border,borderRadius:8,padding:"5px 12px",fontSize:"0.75rem",cursor:"pointer",fontFamily:"inherit"}}>✕</button>
            </div>
            <div style={{fontSize:"0.62rem",color:C.g5,marginBottom:14}}>
              {(function(){
                var mn=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
                var start=new Date();
                var end=new Date();end.setDate(end.getDate()+6);
                return mn[start.getMonth()]+" "+start.getDate()+" – "+mn[end.getMonth()]+" "+end.getDate()+", "+end.getFullYear()+" · Ranked by composite weather score";
              }())}
            </div>
            {districtRanking.map(function(d,i){
              var medal=i===0?"🥇":i===1?"🥈":i===2?"🥉":"";
              var scoreColor=d.score>=2?C.green:d.score>=-1?C.od:C.red;
              return(
                <div key={d.key} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,background:i===0?C.gl:i<3?"#FAFAFA":C.white,border:"1px solid "+(i===0?"#A5D6A7":C.border),marginBottom:6}}>
                  <div style={{width:26,textAlign:"center",flexShrink:0}}>
                    {medal?<span style={{fontSize:"1.1rem"}}>{medal}</span>:<span style={{fontSize:"0.75rem",fontWeight:800,color:C.g3}}>{"#"+(i+1)}</span>}
                  </div>
                  <div style={{width:34,height:34,borderRadius:7,background:C.orange,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <span style={{fontSize:"0.6rem",fontWeight:800,color:C.white}}>{"D"+d.num}</span>
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:"0.8rem",fontWeight:700,color:C.black}}>{d.dm.split(" ").slice(1).join(" ")}</div>
                    <div style={{fontSize:"0.58rem",color:C.g5}}>{d.region+" · "+d.avgH+"°F avg"+( d.rainToday>0?" · "+d.rainToday+" stores w/ rain":"")}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{fontSize:"0.85rem",fontWeight:800,color:scoreColor}}>{d.score>0?"+":""}{d.score}</div>
                    <div style={{fontSize:"0.52rem",color:C.g5}}>score</div>
                  </div>
                </div>
              );
            })}
            <div style={{fontSize:"0.58rem",color:C.g4,marginTop:10,textAlign:"center"}}>Score = avg daily pts: +3 no precip, +2 good cond, +2 at/above seasonal avg, -3 precip</div>
          </div>
        </div>
      )}

          {showAlerts&&(
        <div onClick={()=>setShowAlerts(null)} style={{position:"fixed",inset:0,zIndex:300,background:"rgba(0,0,0,0.55)"}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"fixed",bottom:0,left:0,right:0,maxWidth:600,margin:"0 auto",background:C.white,borderRadius:"16px 16px 0 0",padding:"20px 16px 36px",maxHeight:"75vh",overflowY:"auto",boxShadow:"0 -4px 24px rgba(0,0,0,0.3)"}}>
            <div style={{width:36,height:4,background:C.border,borderRadius:2,margin:"0 auto 16px"}}/>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
              <div>
                <div style={{fontWeight:800,fontSize:"0.95rem",color:C.black}}>{"⚠ Precip Alert Stores"}</div>
                <div style={{fontSize:"0.65rem",color:C.g5,marginTop:2}}>{showAlerts==="il"?"Illinois / Indiana":"Missouri"} · stores with rain or precip today</div>
              </div>
              <button onClick={()=>setShowAlerts(null)} style={{background:C.g1,border:"1px solid "+C.border,borderRadius:8,padding:"5px 12px",fontSize:"0.75rem",cursor:"pointer",fontFamily:"inherit"}}>✕</button>
            </div>
            {(showAlerts==="il"?ilDistricts:moDistricts).map(function(d){
              var alertStores=d.stores.filter(function(s){return FC[s.num]&&condPrecip(FC[s.num].cond);});
              if(!alertStores.length)return null;
              return(
                <div key={d.key} style={{marginBottom:14}}>
                  <div style={{fontSize:"0.65rem",fontWeight:700,color:C.g5,letterSpacing:"0.06em",marginBottom:6}}>{"D"+d.num+" · "+d.dm.toUpperCase()}</div>
                  {alertStores.map(function(s){
                    var w=FC[s.num];
                    return(
                      <div key={s.num} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 12px",background:"#FFF5F5",borderRadius:8,border:"1px solid #FFCDD2",marginBottom:4}}>
                        <div>
                          <div style={{fontSize:"0.82rem",fontWeight:700,color:C.black}}>{s.name}</div>
                          <div style={{fontSize:"0.62rem",color:C.g5}}>{"#"+s.num+" · "+s.state}</div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontSize:"0.78rem",fontWeight:800,color:C.red}}>{w.cond}</div>
                          <div style={{fontSize:"0.62rem",color:C.g5}}>{fhigh(s.num)+"°F · "+w.precip+"% precip"}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}

          {tooltipPill&&(
        <div onClick={function(){setTooltipPill(null);}} style={{position:"fixed",inset:0,zIndex:300,background:"rgba(0,0,0,0.45)"}}>
          <div onClick={function(e){e.stopPropagation();}} style={{position:"fixed",bottom:0,left:0,right:0,maxWidth:600,margin:"0 auto",background:C.black,color:C.white,borderRadius:"16px 16px 0 0",padding:"20px 18px 36px",fontSize:"0.8rem",lineHeight:1.6,boxShadow:"0 -4px 24px rgba(0,0,0,0.4)"}}>
            <div style={{width:36,height:4,background:"rgba(255,255,255,0.2)",borderRadius:2,margin:"0 auto 16px"}}/>
            <button onClick={function(){setTooltipPill(null);}} style={{position:"absolute",top:14,right:14,background:"rgba(255,255,255,0.1)",border:"none",color:"rgba(255,255,255,0.7)",cursor:"pointer",fontFamily:"inherit",fontSize:"0.78rem",borderRadius:6,padding:"4px 10px"}}>{"✕"}</button>
            {tooltipPill==="bestday"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8}}>{"📅 Best Day — This Wk · Next Wk"}</div><div>{"Highest-scoring day per week: dry, sunny, at or above "+avg+"°F seasonal avg. Use for DM visits, event days, or outdoor resets."}</div></>}
            {tooltipPill==="wknd"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8}}>{"🏆 Weekend Score (0–10)"}</div><div style={{display:"flex",gap:8,marginTop:8}}>{[["7-10","Prime","#2E7D32"],["4-6","Moderate",C.od],["0-3","Tough",C.red]].map(function(x){return <div key={x[0]} style={{background:"rgba(255,255,255,0.08)",borderRadius:8,padding:"6px 12px",textAlign:"center"}}><div style={{fontWeight:800,color:x[2]}}>{x[0]}</div><div style={{fontSize:"0.65rem",color:"rgba(255,255,255,0.6)"}}>{x[1]}</div></div>;})}</div></>}
            {tooltipPill==="goodweek"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8}}>{ilGoodPct>=60&&moGoodPct>=60?"✅ Good Selling Week":ilGoodPct>=40&&moGoodPct>=40?"⚠ Mixed Selling Week":"📋 Quote Marathon Week"}</div><div>{ilGoodPct<40||moGoodPct<40?"Under 40% favorable days — open a Quote Marathon and drive project pipeline.":ilGoodPct<60||moGoodPct<60?"Mixed week (40-60% favorable). Balance foot traffic with pipeline building.":"Over 60% favorable days. Focus on conversion and attachment."}</div></>}
            {tooltipPill&&tooltipPill.id==="trend"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8,color:tooltipPill.trendColor||C.white}}>{tooltipPill.trendIcon+" Tomorrow's Trend"}</div><div style={{marginBottom:8}}>{"Tomorrow: "}<b style={{fontSize:"1.1rem"}}>{tooltipPill.tmrHigh+"°F"}</b><span style={{color:"rgba(255,255,255,0.5)",marginLeft:6}}>{" ("+(tooltipPill.trend>0?"+":"")+tooltipPill.trend+"°F)"}</span></div><div style={{display:"flex",gap:4,flexWrap:"wrap"}}>{[["↑↑","+5°+","#2E7D32"],["↑","+2-4°","#4CAF50"],["→","±2°",C.g5],["↓","-2-4°","#64B5F6"],["↓↓","-5°+","#1565C0"]].map(function(x){return <div key={x[0]} style={{background:tooltipPill.trendIcon===x[0]?"rgba(255,255,255,0.15)":"rgba(255,255,255,0.06)",borderRadius:8,padding:"5px 10px",border:tooltipPill.trendIcon===x[0]?"1px solid rgba(255,255,255,0.3)":"1px solid transparent",display:"flex",gap:6,alignItems:"center"}}><span style={{fontWeight:800,color:x[2]}}>{x[0]}</span><span style={{fontSize:"0.65rem",color:"rgba(255,255,255,0.7)"}}>{x[1]}</span></div>;})}</div></>}
            {tooltipPill&&tooltipPill.id==="lw"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8}}>{"📆 vs Last Day ("+LAST_WEEK_DATE+")"}</div><div style={{fontSize:"1.2rem",fontWeight:800,margin:"8px 0",color:tooltipPill.delta>2?C.od:tooltipPill.delta<-2?"#64B5F6":C.g5}}>{(tooltipPill.delta>0?"+":"")+tooltipPill.delta+"°F"}</div><div>{tooltipPill.delta>2?"Warmer — good momentum.":tooltipPill.delta<-2?"Cooler — softer traffic expected.":"Flat vs yesterday."}</div></>}
            {tooltipPill&&tooltipPill.id==="rain"&&<><div style={{fontWeight:800,fontSize:"0.9rem",marginBottom:8}}>{"🌧 Precip Window"}</div><div>{"Significant precip forecast "}<b>{tooltipPill.rainIdx===1?"tomorrow":tooltipPill.rainIdx===2?"in 2 days":"in 3 days"}</b>{"."}</div><div style={{marginTop:8,fontSize:"0.75rem",color:"rgba(255,255,255,0.75)"}}>{"• Pull forward outdoor sets  • Move displays inside  • Great Quote Marathon day"}</div></>}
          </div>
        </div>
      )}

    
        <div style={{textAlign:"center",padding:"20px 0 8px",fontSize:"0.6rem",color:C.g3}}>{"Data: "+DATA_SOURCE+" · "+DATA_DATE+" · vs "+(function(){var d=new Date();d.setFullYear(d.getFullYear()-1);return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});}())}</div>
      </div>
    </div>
  );
}
